import { React, Component } from "react";
// import { Component } from "react";

import { Prompt, Redirect } from "react-router-dom";

//import { Redirect } from "react-router";
import axios from "axios";
import { axiosConfig } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  getService,
  serviceRatesUpdate,
  addCsvFile,
  listDefaultServices,
  check_integrations,
  listClientServiceAgreements,
  listForms,
} from "./../../../config/api_calls";

import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import {
  THEME_TEXT_COLOR,
  THEME_COLOR,
  APP_LIVE_URL,
  AGENT_SERVER_URL,
} from "./../../../config/config";
import Radio from "@material-ui/core/Radio";
import TextField from "../../../components/InputFields/TextField";
import SelectField from "../../../components/InputFields/SelectField";
import MutextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Tooltip from "@material-ui/core/Tooltip";
//import { Editor } from "@tinymce/tinymce-react";
import localization from "../../../localization/enUS";
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import Select2 from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const auth = new HelperClass();

class Editservice extends Component {
  constructor(props) {
    super(props);
    var date = (date = new Date()),
      y = date.getFullYear(),
      m = date.getMonth();
    var datestring_today = new Date().toISOString().slice(0, 10);
    var datestring = new Date().toISOString().slice(0, 10);
    this.decimalPoint = Number(auth.getDecimalPoint());
    this.props = props;
    this.state = {
      serviceData: [],
      defaultServices: [],
      select_service: "",
      product_desc: "",
      product_summary: "",
      rate_margin: 0,
      total_commission: 0,
      errorMessage: "",
      start_date: datestring_today,
      serviceId: "",
      title: "",
      sku: "",
      product_title: "",
      service_title: "",
      service_desc: "",
      service_type: "",
      successMessage: "",
      tableLoader: true,
      radio_buttons: false,
      radio_type: "a",
      nrc_rate_type: "flat",
      min_rate_type: "flat",
      default_nrc: "",
      default_mrc: "",
      update_nrc: "",
      update_mrc: "",
      agent_mrc_comission: 5,
      agent_nrc_comission: 0.0,
      agent_rate_comission: 5,
      sms_in_comission: 5,
      sms_out_comission: 5,
      rate_type: "",
      update_rate: "",
      default_rate: "",
      defaultSessionRate: "",
      product_id: "",
      send_notification: false,
      checked: false,
      default_cnam_dip_local: 0.0,
      default_cnam_dip: 0.0,
      default_cnam_mrc: 0.0,
      cnam_dip_local: 0.0,
      cnam_dip: 0.0,
      cnam_mrc: 0.0,
      cnam_mrc_comission: 5,
      cnam_dip_local_comission: 5,
      cnam_dip_comission: 5,

      cnam_mrc_error: false,
      cnam_mrc_comission_text:
        "Agent Commission in percentage (Applied on Margin)",
      cnam_mrc_error_text:
        "This value should be greater than update CNAM (MRC) buy rate.",
      cnam_dip_error: false,
      cnam_dip_error_text:
        "This value should be greater than CNAM DIP buy rate.",
      cnam_dip_comission_text:
        "Agent Commission in percentage (Applied on Margin)",

      cnam_dip_local_error: false,
      cnam_dip_local_error_text:
        "This value should be greater than Storage DIP buy rate.",
      cnam_dip_local_comission_text:
        "Agent Commission in percentage (Applied on Margin)",
      default_sms_in: "",
      default_sms_out: "",
      sms_in: 0.0,
      sms_out: 0.0,
      mrc_rate_type: "flat",
      select_rate_type: "flat_rate",
      mrc_helper: "This value should be greater than MRC Buy rate.",
      mrc_error: false,
      mrc_error_text: "This value should be greater than MRC buy rate.",
      nrc_error: false,
      nrc_error_text: "This value should be greater than NRC buy rate.",
      rate_error: false,
      rate_error_text: "This value should be greater than per minute buy rate.",
      sms_in_error: false,
      sms_in_comission_text:
        "Agent Commission in percentage (Applied on Margin)",
      sms_in_error_text:
        "This value should be greater than SMS outbound buy rate.",
      sms_out_error: false,
      sms_out_error_text:
        "This value should be greater than SMS outbound buy rate.",
      mrc_comission_error: false,
      sms_out_comission_text:
        "Agent Commission in percentage (Applied on Margin)",
      mrc_comission_error_text:
        "Agent Commission in percentage (Applied on Margin)",
      nrc_comission_error: false,
      nrc_comission_error_text: "",
      rate_comission_error: false,
      rate_comission_error_text: `${localization.specificPortals.agentLabel} Commission in percentage (Applied on Margin)`,
      per_min_type: "",
      per_min_type_title: "",
      rate_deck_file: [],
      marketing_content: "",
      marketing_link: "",
      marketing_pdf: "",
      misc_rows: [],
      generic_rows: [],
      cancellation_fee: "0.00",
      defaultPortIn: "0.00",
      portin: "",
      portin_error: false,
      portin_error_text: "This value should be greater than NRC buy rate.",
      agent_portin_comission: "0.00",
      portin_comission_error: false,
      defaultPortOut: "0.00",
      portout: "",
      portout_error: false,
      portout_error_text: "This value should be greater than NRC buy rate.",
      agent_portout_comission: "0.00",
      portout_comission_error: false,
      rate_settings_tab: true,
      misc_settings_tab: true,
      porting_settings_tab: true,
      desc_settings_tab: true,
      porting_data: [],
      main_type: "",
      isBlocking: true,
      kyc_required: false,
      capture_projection: false,
      allow_rfq: false,
      generic_total: 0,
      generic_buy_total: 0,
      nda_required: false,
      is_default: false,
      product_title: "",

      integrationData: [],
      documentTitle: "",
      documentFile: "",
      document: "",
      documentFileName: "",
      select_integration: "",
      docErrorMessage: "",
      docs_settings_tab: true,
      intigration_settings_tab: true,
      isEditorReady: false,

      all_active_agreements: [],
      selected_agreement: "",
      selected_agreement_array: null,

      all_active_forms: [],
      selected_form: "",
      selected_form_array: null,
      isCpDefault: true,
      isComingSoon: false,
      rate_deck_pricing: false,
      rate_deck_file_error: false,
      rate_deck_file_error_text: "",
    };
  }
  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };
  serviceSigning = async (value, tableMeta) => {
    // console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    this.setState({
      errorMessage: "",
      successMessage: "",
      main_type: "",
    });
    let service_id = this.props.props.match.params.id;
    let default_services = await this.get_default_services();
    // console.log("default_services return: ", default_services);
    if (default_services) {
      const servicesResponce = await getService(
        auth.getAccount(),
        auth.getToken(),
        service_id,
      );
      // console.log("getService Edit: ", servicesResponce.data.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          errorMessage: "There is some error while getting the service data.",
          successMessage: "",
        });
        //window.location.replace("/error");
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        let mrc_percentage =
          (servicesResponce.data.data[0][5] -
            servicesResponce.data.data[0][15]) *
          (servicesResponce.data.data[0][12] / 100);
        mrc_percentage = this.formatRate(mrc_percentage);

        let rate_percentage =
          (servicesResponce.data.data[0][7] -
            servicesResponce.data.data[0][16]) *
          (servicesResponce.data.data[0][14] / 100);
        rate_percentage = this.formatRate(rate_percentage);

        let sms_in_percentage =
          (servicesResponce.data.data[0][10] -
            servicesResponce.data.data[0][15]) *
          (servicesResponce.data.data[0][17] / 100);
        sms_in_percentage = this.formatRate(sms_in_percentage);

        let sms_out_percentage =
          (servicesResponce.data.data[0][11] -
            servicesResponce.data.data[0][16]) *
          (servicesResponce.data.data[0][18] / 100);
        sms_out_percentage = this.formatRate(sms_out_percentage);

        let cnam_dip_local_percentage = "";
        let cnam_dip_percentage = "";
        let cnam_mrc_percentage = "";
        if (servicesResponce.data.data[0][6] === "cnam") {
          cnam_dip_local_percentage =
            (servicesResponce.data.data[0][35] -
              servicesResponce.data.data[0][38]) *
            (servicesResponce.data.data[0][40] / 100);
          cnam_dip_local_percentage = this.formatRate(
            cnam_dip_local_percentage,
          );
          cnam_dip_percentage =
            (servicesResponce.data.data[0][34] -
              servicesResponce.data.data[0][37]) *
            (servicesResponce.data.data[0][41] / 100);
          cnam_dip_percentage = this.formatRate(cnam_dip_percentage);
          cnam_mrc_percentage =
            (servicesResponce.data.data[0][33] -
              servicesResponce.data.data[0][36]) *
            (servicesResponce.data.data[0][39] / 100);
          cnam_mrc_percentage = this.formatRate(cnam_mrc_percentage);
        }

        let default_settings = [];
        let porting_data = [];
        let porting_portin_default_rate = "";
        let porting_portin_sell_rate = "";
        let porting_portin_spiff = "";
        let porting_portout_default_rate = "";
        let porting_portout_sell_rate = "";
        let porting_portout_spiff = "";

        if (
          this.state.defaultServices &&
          this.state.defaultServices.length > 0
        ) {
          default_settings = this.get_services_settings(
            servicesResponce.data.data[0][8],
          );
          // console.log("default_settings: ", default_settings);
          // console.log(
          //   "servicesResponce.data.data[0][8]: ",
          //   servicesResponce.data.data[0][8]
          // );
          if (
            servicesResponce.data.data[0][30] &&
            servicesResponce.data.data[0][30].length > 0
          ) {
            porting_data = servicesResponce.data.data[0][30];
            porting_portin_default_rate = this.formatRate(
              servicesResponce.data.data[0][30][0].portin_default_rate,
            );
            porting_portin_sell_rate = this.formatRate(
              servicesResponce.data.data[0][30][0].portin_sell_rate,
            );
            porting_portin_spiff = this.formatRate(
              servicesResponce.data.data[0][30][0].portin_agent_spiff,
            );
            porting_portout_default_rate = this.formatRate(
              servicesResponce.data.data[0][30][0].portout_default_rate,
            );
            porting_portout_sell_rate = this.formatRate(
              servicesResponce.data.data[0][30][0].portout_sell_rate,
            );
            porting_portout_spiff = this.formatRate(
              servicesResponce.data.data[0][30][0].portout_agent_spiff,
            );
          } else {
            // console.log("default_settings here: ", default_settings);
            if (default_settings) {
              porting_data = [];
              porting_portin_default_rate = this.formatRate(
                default_settings[12],
              );
              porting_portin_sell_rate = "";
              porting_portin_spiff = "";
              porting_portout_default_rate = this.formatRate(
                default_settings[11],
              );
              porting_portout_sell_rate = "";
              porting_portout_spiff = "";
            } else {
              porting_data = [];
              porting_portin_default_rate = "";
              porting_portin_sell_rate = "";
              porting_portin_spiff = "";
              porting_portout_default_rate = "";
              porting_portout_sell_rate = "";
              porting_portout_spiff = "";
            }
          }
        }
        let defaultSessionRate = "";
        if (servicesResponce.data.data[0][6] !== "cnam") {
          if (servicesResponce.data.data[0][32]) {
            defaultSessionRate = this.formatRate(
              servicesResponce.data.data[0][32],
            );
          } else {
            if (default_settings) {
              defaultSessionRate = this.formatRate(default_settings[10]);
            }
          }
        }
        let kyc_required =
          servicesResponce.data.data[0][44] === "Yes" ? true : false;
        let capture_projection =
          servicesResponce.data.data[0][45] === "Yes" ? true : false;

        let allow_rfq =
          servicesResponce.data.data[0][47] === "Yes" ? true : false;

        let nda_required =
          servicesResponce.data.data[0][49] === "Yes" ? true : false;

        let is_default =
          servicesResponce.data.data[0][9] === "Yes" ? true : false;

        //Calculation for Generic Service
        let generic_total = 0;
        let generic_buy_total = 0;
        let generic_rows_data = [];
        if (servicesResponce.data.data[0][6] === "generic") {
          if (
            servicesResponce.data.data[0][46] &&
            servicesResponce.data.data[0][46].length > 0
          ) {
            generic_rows_data = servicesResponce.data.data[0][46];
            for (let i = 0; i < generic_rows_data.length; i++) {
              // Ensure includedInPrice defaults to true if not set
              if (
                generic_rows_data[i].includedInPrice === undefined ||
                generic_rows_data[i].includedInPrice === null
              ) {
                generic_rows_data[i].includedInPrice = true;
              }
              if (
                generic_rows_data[i]["generic_rate"] &&
                generic_rows_data[i].includedInPrice !== false
              ) {
                generic_total =
                  generic_total + generic_rows_data[i]["generic_rate"];
              }
              if (
                generic_rows_data[i]["generic_buy_rate"] &&
                generic_rows_data[i].includedInPrice !== false
              ) {
                generic_buy_total =
                  generic_buy_total + generic_rows_data[i]["generic_buy_rate"];
              }
            }
          }
        } else if (servicesResponce.data.data[0][46]) {
          // For non-generic services, still ensure includedInPrice is set
          generic_rows_data = servicesResponce.data.data[0][46];
          for (let i = 0; i < generic_rows_data.length; i++) {
            if (
              generic_rows_data[i].includedInPrice === undefined ||
              generic_rows_data[i].includedInPrice === null
            ) {
              generic_rows_data[i].includedInPrice = true;
            }
          }
        }

        this.setState({
          // serviceData: servicesResponce.data.data,
          serviceId: servicesResponce.data.data[0][0],
          product_title: servicesResponce.data.data[0][2],
          update_nrc: servicesResponce.data.data[0][4],
          update_mrc: servicesResponce.data.data[0][5],
          update_rate: this.formatRate(servicesResponce.data.data[0][7]),
          service_title: servicesResponce.data.data[0][1],
          sku: servicesResponce.data.data[0][48],
          select_service: servicesResponce.data.data[0][8],
          service_type: servicesResponce.data.data[0][6],
          sms_in: servicesResponce.data.data[0][10],
          sms_out: servicesResponce.data.data[0][11],
          product_desc: servicesResponce.data.data[0][3],
          agent_mrc_comission: servicesResponce.data.data[0][12],
          agent_nrc_comission: servicesResponce.data.data[0][13],
          agent_rate_comission: servicesResponce.data.data[0][14],
          sms_in_comission: servicesResponce.data.data[0][17],
          sms_out_comission: servicesResponce.data.data[0][18],
          default_mrc: this.formatRate(servicesResponce.data.data[0][15]),
          default_rate: this.formatRate(servicesResponce.data.data[0][16]),
          default_nrc: this.formatRate(servicesResponce.data.data[0][21]),

          default_cnam_dip_local: servicesResponce.data.data[0][38],
          default_cnam_dip: servicesResponce.data.data[0][37],
          default_cnam_mrc: servicesResponce.data.data[0][36],
          cnam_dip_local: servicesResponce.data.data[0][35],
          cnam_dip: servicesResponce.data.data[0][34],
          cnam_mrc: servicesResponce.data.data[0][33],
          cnam_mrc_comission: servicesResponce.data.data[0][39],
          cnam_dip_local_comission: servicesResponce.data.data[0][40],
          cnam_dip_comission: servicesResponce.data.data[0][41],
          marketing_content: servicesResponce.data.data[0][42],
          marketing_link: servicesResponce.data.data[0][43],
          cnam_dip_local_comission_text:
            "Agent Commission in percentage (Applied on Margin): Est. $" +
            cnam_dip_local_percentage,
          cnam_dip_comission_text:
            "Agent Commission in percentage (Applied on Margin): Est. $" +
            cnam_dip_percentage,
          cnam_mrc_comission_text:
            "Agent Commission in percentage (Applied on Margin): Est. $" +
            cnam_mrc_percentage,

          default_sms_in: this.formatRate(servicesResponce.data.data[0][26]),
          default_sms_out: this.formatRate(servicesResponce.data.data[0][27]),
          sms_in_comission_text:
            "Agent Commission in percentage (Applied on Margin): Est. $" +
            sms_in_percentage,
          sms_out_comission_text:
            "Agent Commission in percentage (Applied on Margin): Est. $" +
            sms_out_percentage,
          mrc_comission_error_text:
            "Agent Commission in percentage (Applied on Margin): Est. $" +
            mrc_percentage,
          rate_comission_error_text: `${localization.specificPortals.agentLabel} Commission in percentage (Applied on Margin)`,
          main_type: servicesResponce.data.data[0][23],
          per_min_type: servicesResponce.data.data[0][28],
          cancellation_fee: this.formatRate(servicesResponce.data.data[0][29]),
          porting_data: porting_data,
          misc_rows: servicesResponce.data.data[0][31],
          generic_rows:
            generic_rows_data.length > 0
              ? generic_rows_data
              : servicesResponce.data.data[0][46] || [],
          defaultPortIn: porting_portin_default_rate,
          portin: porting_portin_sell_rate,
          agent_portin_comission: porting_portin_spiff,
          defaultPortOut: porting_portout_default_rate,
          portout: porting_portout_sell_rate,
          agent_portout_comission: porting_portout_spiff,
          defaultSessionRate: defaultSessionRate,
          kyc_required: kyc_required,
          capture_projection: capture_projection,
          allow_rfq: allow_rfq,
          nda_required: nda_required,
          is_default: is_default,
          tableLoader: false,
          errorMessage: "",
          generic_total: this.formatRate(generic_total),
          generic_buy_total: this.formatRate(generic_buy_total),
          documentFile: servicesResponce.data.data[0][51],
          documentFileName: "",
          documentTitle: servicesResponce.data.data[0][50],
          select_integration: servicesResponce.data.data[0][52],
          product_summary: servicesResponce.data.data[0][54],
          rate_margin: servicesResponce.data.data[0][55],
          total_commission: servicesResponce.data.data[0][56],
          selected_agreement: servicesResponce.data.data[0][57],
          selected_form: servicesResponce.data.data[0][58],
          isCpDefault: servicesResponce.data.data[0][59],
          isComingSoon: servicesResponce.data.data[0][60],
          rate_deck_pricing:
            servicesResponce.data.data[0][61] === 1 ? true : false,
          isEditorReady: true,
        });
      } else {
        this.setState({
          errorMessage: "There is some error while getting the service data.",
          successMessage: "",
        });
      }
    }
    this.intigrations();
    this.getAllAgreements();
    this.getAllForms();
  }

  intigrations = async () => {
    const servicesResponce = await check_integrations(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("check  integrations: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        integrationData: servicesResponce.data.data,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  /*handleEditorChange = (event, editor) => {
    const content = editor.getData();
    this.setState({
      product_desc: content
    });
  };*/

  getAllForms = async () => {
    let service_id = this.props.props.match.params.id;
    const servicesResponce = await listForms(
      auth.getAccount(),
      auth.getToken(),
      service_id,
    );

    // console.log("listFormsUpdate: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_forms = [];
      let first_value = null;
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          if (
            servicesResponce.data.data[i].form_accountno ==
            this.state.selected_form
          ) {
            first_value = servicesResponce.data.data[i].form_accountno;
          }
          let newArr = {
            label: servicesResponce.data.data[i].form_title,
            value: servicesResponce.data.data[i].form_accountno,
          };
          all_forms.push(newArr);
        }
      }
      // console.log("first_value_form: ", first_value);
      this.setState({
        all_active_forms: all_forms,
        tableLoader: false,
      });
      if (first_value && first_value !== "") {
        let get_initial_selection = this.getInitialFormSelectedOption(
          first_value,
          all_forms,
        );
        // console.log("get_initial_selection: ", get_initial_selection);

        this.setState(
          (prevState) => ({
            selected_form_array: get_initial_selection,
            selected_form: get_initial_selection.value,
          }),
          () => {
            // This callback function is called right after the state is updated
            //console.log("Updated state:", this.state.service_type_id);
          },
        );
      }
    } else {
      //window.location.replace("/error");
    }
  };

  getInitialFormSelectedOption = (value, all_clients) => {
    // Retrieve the initial selected option from your options array
    let options = all_clients; // Replace with your actual options array

    // console.log("value: ", value);
    // console.log("all_clients: ", all_clients);

    if (options) {
      return options.find((option) => option.value === value) || null;
    }
  };

  handleChangeSearchForm = async (changed_value) => {
    // console.log("handleChangeSearchForm: ", changed_value);

    if (changed_value) {
      this.setState(
        (prevState) => ({
          selected_form: changed_value.value,
          selected_form_array: changed_value,
        }),
        () => {
          // This callback function is called right after the state is updated
          //this.getClientAgreement(this.state.selected_form);
          // console.log("Updated state:", this.state.selected_form);
        },
      );
    } else {
      this.setState(
        {
          selected_form: null,
          selected_form_array: null,
        },
        () => {
          let agreement = "";
          //this.getClientAgreement(agreement);
          // console.log("Cleared selection");
        },
      );
    }
  };

  getAllAgreements = async () => {
    const servicesResponce = await listClientServiceAgreements(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("Agreement Res: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_agreements = [];
      let first_value = null;
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          if (
            servicesResponce.data.data[i][2] === 1 &&
            servicesResponce.data.data[i][9] !== "duplicate"
          ) {
            if (
              servicesResponce.data.data[i][7] == this.state.selected_agreement
            ) {
              first_value = servicesResponce.data.data[i][7];
            }
            let newArr = {
              label: servicesResponce.data.data[i][1],
              value: servicesResponce.data.data[i][7],
            };
            all_agreements.push(newArr);
          }
        }
      }
      // console.log("first_value: ", first_value);
      this.setState({
        all_active_agreements: all_agreements,
        tableLoader: false,
      });
      if (first_value && first_value !== "") {
        let get_initial_selection = this.getInitialSelectedOption(
          first_value,
          all_agreements,
        );
        this.setState(
          (prevState) => ({
            selected_agreement_array: get_initial_selection,
            selected_agreement: get_initial_selection.value,
          }),
          () => {
            // This callback function is called right after the state is updated
            //console.log("Updated state:", this.state.service_type_id);
          },
        );
      }
    } else {
      //window.location.replace("/error");
    }
  };

  getInitialSelectedOption = (value, all_clients) => {
    // Retrieve the initial selected option from your options array
    let options = all_clients; // Replace with your actual options array

    if (options) {
      return options.find((option) => option.value === value) || null;
    }
  };

  handleChangeSearchAgreement = async (changed_value) => {
    // console.log("handleChangeSearchAgreement: ", changed_value);

    if (changed_value) {
      this.setState(
        (prevState) => ({
          selected_agreement: changed_value.value,
          selected_agreement_array: changed_value,
        }),
        () => {
          // This callback function is called right after the state is updated
          //this.getClientAgreement(this.state.selected_agreement);
          // console.log("Updated state:", this.state.selected_agreement);
        },
      );
    } else {
      this.setState(
        {
          selected_agreement: null,
          selected_agreement_array: null,
        },
        () => {
          let agreement = "";
          //this.getClientAgreement(agreement);
          // console.log("Cleared selection");
        },
      );
    }
  };

  handleEditorChange = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState({ product_desc: updatedContent });
  };

  get_default_services = async () => {
    const servicesResponce = await listDefaultServices(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("get_default_services: ", servicesResponce.data.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      return false;
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        defaultServices: servicesResponce.data.data,
      });
      return true;
    } else {
      //window.location.replace("/error");
      return false;
    }
  };

  get_services_settings = (service_id) => {
    // console.log("get_services_settings: ", service_id);
    let default_services = this.state.defaultServices;
    for (var i = 0; i < default_services.length; i++) {
      if (service_id === default_services[i][0]) {
        // console.log(
        //   "get_services_settings Res: ",
        //   service_id + " " + default_services[i][0]
        // );
        return default_services[i];
      }
    }
  };

  setMarkUp = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });

    // console.log("setMarkup: ", name + " " + value);
    let service_data = this.state.serviceData;
    //
    service_data.map((services) => {
      if (services["product_id"] == value) {
        // console.log("service_type: ", services.service_type);
        this.setState({
          product_id: services.product_id,
          defaultNrc: this.formatRate(services.nrc),
          defaultMrc: this.formatRate(services.mrc),
          rate_type: services.rate_type,
          defaultRate: this.formatRate(services.rate),
          service_title: services.product_title,
          product_desc: services.product_desc,
          defaultSmsIn: services.sms_in,
          defaultSmsOut: services.sms_out,
          service_type: services.service_type,
          //defaultSessionRate: services.session_unmetered,
          defaultPortIn: services.portin_charges,
          defaultPortOut: services.portout_charges,
          rate_settings_tab: true,
          isBlocking: false,
        });
      }
    });
  };

  open_current_tab = (link) => {
    this.setState({
      [link]: true,
    });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleChangeDefault = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
      isBlocking: false,
    });
    // console.log("handleChangeDefault: ", name + " " + value);
    let service_data = this.state.defaultServices;
    // console.log("serviceData: ", service_data);
    for (let i = 0; i < service_data.length; i++) {
      if (service_data[i][0] == value) {
        this.setState({
          product_title: service_data[i][1],
          product_id: service_data[i][0],
          //defaultNrc: this.formatRate(service_data[i][3]),
          //defaultMrc: this.formatRate(service_data[i][4]),
          //rate_type: service_data[i][5],
          //defaultRate: this.formatRate(service_data[i][5]),
          //defaultSmsIn: service_data[i][7],
          //defaultSmsOut: service_data[i][8],
          //service_type: service_data[i][9],
        });
      }
    }
  };

  handleChange = async (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "cancellation_fee") {
      value = this.handleRateRestrictions(value);
    }
    this.setState({
      [name]: value,
      isBlocking: false,
    });
    //console.log("handleChange:", name + " " + value);
    this.handlePercentage(name, value);
    if (name === "agent_rate_comission") {
      setTimeout(() => {
        this.calculateMargin();
      }, 1000);
    }
  };

  handleChangeCheckbox = async (event) => {
    const { target } = event;
    const value = target.type === "radio" ? target.value : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
      isBlocking: false,
    });

    // console.log("handleChangeCheckbox:", name + " " + value);
  };

  handleChangeCheckboxKyc = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
      isBlocking: false,
    });

    // console.log("handleChangeCheckbox:", name + " " + value);
  };

  saveFilePdf = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      return;
    }

    // File type validation for images and PDFs
    const allowedFileTypes = [".pdf", ".jpg", ".jpeg", ".png"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (!allowedFileTypes.includes(`.${fileExtension}`)) {
      this.setState({
        errorMessage:
          "Invalid file type. Please select a PDF, JPG, or PNG file.",
        file: [],
        fileName: "",
      });
      return;
    }

    // File size validation (2MB limit)
    const maxSizeBytes = 2 * 1024 * 1024; // 2MB
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        errorMessage:
          "File size exceeds the limit (2MB). Please choose a smaller file.",
        file: [],
        fileName: "",
      });
      return;
    }

    this.setState({
      file: selectedFile,
      fileName: selectedFile.name,
      errorMessage: "",
    });
  };

  handleChangeRadio = async (event) => {
    const { target } = event;
    const value = target.value;
    const { name } = target;

    this.setState({
      [name]: value,
      isBlocking: false,
    });
    //console.log("handleChange:", name + " " + value);
  };

  handleChangeMrc = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
      isBlocking: false,
    });
    // console.log("handleChangeMrc:", name + " " + value);
    //Calculate MRC PERCENTAGE
    this.handlePercentage(name, value);
  };

  handlePercentage = async (name, value) => {
    //Allowed Percentages for new_mrc, agent_mrc_comission, rate, agent_rate_comission, sms_in, sms_out, sms_in_commission, sms_out_commission
    if (name === "update_mrc") {
      if (value > this.state.default_mrc) {
        let mrc_diff = value - this.state.default_mrc;
        let mrc_percentage = (mrc_diff / 100) * this.state.agent_mrc_comission;

        this.setState({
          mrc_comission_error_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(mrc_percentage) +
            ")",
        });
      }
    }

    if (name === "agent_mrc_comission") {
      if (this.state.update_mrc > this.state.default_mrc) {
        let mrc_diff = this.state.update_mrc - this.state.default_mrc;
        let mrc_percentage = (mrc_diff / 100) * value;

        this.setState({
          mrc_comission_error_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(mrc_percentage) +
            ")",
        });
      }
    }

    if (name === "update_rate") {
      if (value > this.state.default_rate) {
        let mrc_diff = value - this.state.default_rate;
        let mrc_percentage = (mrc_diff / 100) * this.state.agent_rate_comission;

        this.setState({
          rate_comission_error_text:
            "Agent Commission in percentage (Applied on Margin).",
        });
      }
    }

    if (name === "agent_rate_comission") {
      if (this.state.update_rate > this.state.default_rate) {
        let mrc_diff = this.state.update_rate - this.state.default_rate;
        let mrc_percentage = (mrc_diff / 100) * value;

        this.setState({
          rate_comission_error_text:
            "Agent Commission in percentage (Applied on Margin).",
        });
      }
    }

    if (name === "sms_in") {
      if (value > this.state.default_sms_in) {
        let mrc_diff = value - this.state.default_sms_in;
        let mrc_percentage = (mrc_diff / 100) * this.state.sms_in_comission;

        this.setState({
          sms_in_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(mrc_percentage) +
            ")",
        });
      }
    }

    if (name === "sms_in_comission") {
      if (this.state.sms_in > this.state.default_sms_in) {
        let mrc_diff = this.state.sms_in - this.state.default_sms_in;
        let mrc_percentage = (mrc_diff / 100) * value;

        this.setState({
          sms_in_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(mrc_percentage) +
            ")",
        });
      }
    }

    if (name === "sms_out") {
      if (value > this.state.default_sms_out) {
        let mrc_diff = value - this.state.default_sms_out;
        let mrc_percentage = (mrc_diff / 100) * this.state.sms_out_comission;

        this.setState({
          sms_out_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(mrc_percentage) +
            ")",
        });
      }
    }
    if (name === "sms_out_comission") {
      if (this.state.sms_out > this.state.default_sms_out) {
        let mrc_diff = this.state.sms_out - this.state.default_sms_out;
        let mrc_percentage = (mrc_diff / 100) * value;

        this.setState({
          sms_out_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(mrc_percentage) +
            ")",
        });
      }
    }
    if (name === "cnam_mrc") {
      if (value > this.state.default_cnam_mrc) {
        let mrc_diff = value - this.state.default_cnam_mrc;
        let cnam_mrc_percentage =
          (mrc_diff / 100) * this.state.cnam_mrc_comission;

        this.setState({
          cnam_mrc_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(cnam_mrc_percentage) +
            ")",
        });
      }
    }
    if (name === "cnam_mrc_comission") {
      if (this.state.cnam_mrc > this.state.default_cnam_mrc) {
        let mrc_diff = this.state.cnam_mrc - this.state.default_cnam_mrc;
        let cnam_mrc_comission_percentage = (mrc_diff / 100) * value;

        this.setState({
          cnam_mrc_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(cnam_mrc_comission_percentage) +
            ")",
        });
      }
    }
    if (name === "cnam_dip") {
      if (value > this.state.default_cnam_dip) {
        let mrc_diff = value - this.state.default_cnam_dip;
        let cnam_dip_percentage =
          (mrc_diff / 100) * this.state.cnam_dip_comission;

        this.setState({
          cnam_dip_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(cnam_dip_percentage) +
            ")",
        });
      }
    }
    if (name === "cnam_dip_comission") {
      if (this.state.cnam_dip > this.state.default_cnam_dip) {
        let mrc_diff = this.state.cnam_dip - this.state.default_cnam_dip;
        let cnam_dip_comission_percentage = (mrc_diff / 100) * value;

        this.setState({
          cnam_dip_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(cnam_dip_comission_percentage) +
            ")",
        });
      }
    }
    if (name === "cnam_dip_local") {
      if (value > this.state.default_cnam_dip_local) {
        let mrc_diff = value - this.state.default_cnam_dip_local;
        let cnam_dip_local_percentage =
          (mrc_diff / 100) * this.state.cnam_dip_local_comission;

        this.setState({
          cnam_dip_local_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(cnam_dip_local_percentage) +
            ")",
        });
      }
    }
    if (name === "cnam_dip_local_comission") {
      if (this.state.cnam_dip_local > this.state.default_cnam_dip_local) {
        let mrc_diff =
          this.state.cnam_dip_local - this.state.default_cnam_dip_local;
        let cnam_dip_local_comission_percentage = (mrc_diff / 100) * value;

        this.setState({
          cnam_dip_local_comission_text:
            "Agent Commission in percentage (Applied on Margin). (Estimated: $" +
            this.formatRate(cnam_dip_local_comission_percentage) +
            ")",
        });
      }
    }
  };

  handleDateChange = async (date) => {
    await this.handleStatesDynamic(
      "start_date",
      date.toISOString().slice(0, 10),
    );
    // console.log("start_date " + this.state.start_date);
  };
  handleStatesDynamic = async (start_date, date) => {
    this.setState({
      [start_date]: date,
      isBlocking: false,
    });
  };

  handleChangeFile = async (event) => {
    this.setState({
      rate_deck_file: event.target.files[0],
      isBlocking: false,
    });
    //await this.sendFileData(event.target.files[0]);
  };

  handleChangeMisc = (idx) => (e) => {
    let { name, value } = e.target;
    let misc_rows = [...this.state.misc_rows];
    if (name === "misc_rate") {
      value = this.handleRateRestrictions(value);
    }
    misc_rows[idx][name] = value;

    this.setState({
      misc_rows,
      isBlocking: false,
    });
    // console.log("handleChangeMisc: ", misc_rows);
    // console.log("handleChangeMisc idx: ", idx);
  };
  handleAddRow = () => {
    const item = {
      misc_title: "",
      misc_type: "",
      misc_rate: "",
    };
    this.setState({
      misc_rows: [...this.state.misc_rows, item],
    });
  };
  handleRemoveRow = () => {
    this.setState({
      misc_rows: this.state.misc_rows.slice(0, -1),
    });
  };
  handleRemoveSpecificRow = (idx) => () => {
    const misc_rows = [...this.state.misc_rows];
    misc_rows.splice(idx, 1);
    this.setState({ misc_rows });
  };

  handleChangeGeneric = (idx) => (e) => {
    let { name, value } = e.target;
    let generic_rows = [...this.state.generic_rows];
    if (name === "generic_buy_rate" || name === "generic_rate") {
      value = this.handleRateRestrictions(value);
    }
    generic_rows[idx][name] = value;
    // Ensure includedInPrice is set if undefined
    if (generic_rows[idx].includedInPrice === undefined) {
      generic_rows[idx].includedInPrice = true;
    }
    // console.log("generic_rows[idx][name]: ", name);

    this.setState({
      generic_rows,
      isBlocking: false,
    });

    if (name === "generic_rate") {
      this.calculateTotalRate();
    }
    if (name === "generic_buy_rate") {
      this.calculateTotalBuyRate();
    }
    //
    this.calculateMargin();
  };

  calculateTotalRate = () => {
    let generic_rows = this.state.generic_rows;
    // console.log("calculateTotalRate: ", generic_rows);
    let total = 0;

    if (generic_rows && generic_rows.length > 0) {
      for (let i = 0; i < generic_rows.length; i++) {
        if (
          generic_rows[i].generic_rate &&
          generic_rows[i].includedInPrice !== false
        ) {
          total = total + Number(generic_rows[i].generic_rate);
        }
      }
    }
    this.setState({
      update_rate: this.formatRate(total),
      generic_total: this.formatRate(total),
    });
  };

  calculateTotalBuyRate = async () => {
    let generic_rows = this.state.generic_rows;
    // console.log("calculateTotalBuyRate: ", generic_rows);
    let total = 0;

    if (generic_rows && generic_rows.length > 0) {
      for (let i = 0; i < generic_rows.length; i++) {
        if (
          generic_rows[i].generic_buy_rate &&
          generic_rows[i].includedInPrice !== false
        ) {
          total = total + Number(generic_rows[i].generic_buy_rate);
        }
      }
    }
    // console.log("generic_buy_total: ", total);
    this.setState({
      default_rate: this.formatRate(total),
      generic_buy_total: this.formatRate(total),
    });
  };

  calculateMargin = () => {
    let generic_rows = this.state.generic_rows;
    let agent_rate_comission = this.state.agent_rate_comission;
    //Calculate Price
    //console.log("calculateMargin generic_rows: " + JSON.stringify(generic_rows));
    let rate = 0;
    if (generic_rows && generic_rows.length > 0) {
      for (let i = 0; i < generic_rows.length; i++) {
        if (
          generic_rows[i].generic_rate &&
          generic_rows[i].includedInPrice !== false
        ) {
          //console.log("rate - generic_rows[i].generic_rate: " + rate  + " - " + generic_rows[i].generic_rate);
          rate = Number(rate) + Number(generic_rows[i].generic_rate);
        }
      }
    }
    //Calculate Cost
    let defaultRate = 0;
    if (generic_rows && generic_rows.length > 0) {
      for (let i = 0; i < generic_rows.length; i++) {
        if (
          generic_rows[i].generic_buy_rate &&
          generic_rows[i].includedInPrice !== false
        ) {
          defaultRate =
            Number(defaultRate) + Number(generic_rows[i].generic_buy_rate);
        }
      }
    }
    // console.log("rate - defaultRate: " + rate  + " - " + defaultRate);
    let commission = rate - defaultRate;

    if (commission <= 0) {
      commission = 0;
    }
    //console.log("commission: ", commission);
    let mrc_percentage = (commission / 100) * agent_rate_comission;
    //console.log("commission percentage: ", mrc_percentage);

    this.setState({
      rate_margin: this.formatRate(commission),
      total_commission: this.formatRate(mrc_percentage),
    });
  };

  handleRateRestrictions = (value) => {
    // Remove non-digit characters except '.' and restrict the number of decimal places
    let validatedValue = value.replace(/[^\d.]/g, "");
    const decimalIndex = validatedValue.indexOf(".");

    // Restrict the number of digits before the decimal point to 12
    if (decimalIndex !== -1) {
      const digitsBeforeDecimal = decimalIndex;
      if (digitsBeforeDecimal > 12) {
        validatedValue =
          validatedValue.substring(0, 12) +
          validatedValue.substring(decimalIndex);
      }
    } else {
      if (validatedValue.length > 12) {
        validatedValue = validatedValue.substring(0, 12);
      }
    }

    // Restrict the number of decimal places to this.decimalPoint
    if (
      decimalIndex !== -1 &&
      validatedValue.length - decimalIndex - 1 > this.decimalPoint
    ) {
      validatedValue = validatedValue.substring(
        0,
        decimalIndex + this.decimalPoint + 1,
      );
    }

    return validatedValue;
  };

  /*formatRate = (rate) => {
    if (typeof rate !== "number") {
      rate = parseFloat(rate);
    }

    if (rate === 0) {
      return "0.00";
    }

    const rateString = rate.toString();
    const decimalIndex = rateString.indexOf(".");

    if (decimalIndex === -1) {
      return `${rateString}.00`;
    }

    const decimalPlaces = rateString.length - decimalIndex - 1;
    console.log("decimalPlaces Start: "+ rate + " " + decimalPlaces);
    let displayDecimalPlaces;
    if (decimalPlaces < 2) {
      displayDecimalPlaces = 2;
    } else if (decimalPlaces < this.decimalPoint) {
      displayDecimalPlaces = this.decimalPoint;
    } else {
      displayDecimalPlaces = this.decimalPoint;
      // Rounding only when decimal places exceed this.decimalPoint
      rate = parseFloat(rate.toFixed(this.decimalPoint + 1));
    }
    ///displayDecimalPlaces = this.decimalPoint;
    let formattedRate;
    console.log(
      "displayDecimalPlaces: " +
        displayDecimalPlaces +
        " this.decimalPoint: " +
        this.decimalPoint
    );
    if (displayDecimalPlaces <= 2) {
      formattedRate = parseFloat(rate).toFixed(2);
    } else {
      formattedRate = parseFloat(rate).toFixed(displayDecimalPlaces);
      //formattedRate = formattedRate.replace(/\.?0+$/, '');
    }

    return formattedRate;
  };*/
  formatRate = (rate) => {
    // Ensure rate is a number
    if (typeof rate !== "number") {
      rate = parseFloat(rate);
    }

    // Handle case where rate is NaN (invalid input)
    if (isNaN(rate)) {
      return "Invalid rate";
    }

    // Handle case where rate is zero
    if (rate === 0) {
      return (0).toFixed(this.decimalPoint);
    }

    // Round the rate to the specified decimal points
    const formattedRate = rate.toFixed(this.decimalPoint);

    return formattedRate;
  };

  handleAddRowGeneric = () => {
    const item = {
      generic_title: "",
      generic_type: "",
      generic_rate: "",
      generic_buy_rate: "",
      pay_type: "",
      includedInPrice: true,
    };
    this.setState({
      generic_rows: [...this.state.generic_rows, item],
    });
    //console.log("handleAddRowGeneric: ", this.state.generic_rows);
  };

  handleRemoveRowGeneric = () => {
    this.setState({
      generic_rows: this.state.generic_rows.slice(0, -1),
    });
    this.calculateTotalRate();
  };

  handleToggleIncludeInPrice = (idx) => () => {
    const generic_rows = [...this.state.generic_rows];
    generic_rows[idx].includedInPrice = !generic_rows[idx].includedInPrice;
    this.setState({ generic_rows, isBlocking: false });
    setTimeout(() => {
      this.calculateTotalRate();
      this.calculateTotalBuyRate();
      this.calculateMargin();
    }, 100);
  };

  handleRemoveSpecificRowGeneric = (idx) => () => {
    const generic_rows = [...this.state.generic_rows];
    generic_rows.splice(idx, 1);
    this.setState({ generic_rows });
    setTimeout(() => {
      this.calculateTotalRate();
    }, 500);
  };

  sendFileData = async (filedata) => {
    const saveResponces = await addCsvFile(auth.getAccount(), auth.getToken());
    // console.log("rate_deck_file: ", saveResponces);
  };

  formSave = async (e) => {
    e.preventDefault();
    let {
      select_service,
      service_type,
      update_nrc,
      update_mrc,
      default_nrc,
      default_mrc,
      update_rate,
      default_rate,
      default_sms_in,
      default_sms_out,
      sms_in,
      sms_out,
      rate_type,
      service_title,
      agent_mrc_comission,
      agent_nrc_comission,
      agent_rate_comission,
      sms_in_comission,
      sms_out_comission,
      product_desc,
      per_min_type,
      misc_rows,
      generic_rows,
      cancellation_fee,
      defaultPortIn,
      portin,
      agent_portin_comission,
      defaultPortOut,
      portout,
      agent_portout_comission,
      serviceId,
      default_cnam_dip_local,
      default_cnam_dip,
      default_cnam_mrc,
      cnam_dip_local,
      cnam_dip,
      cnam_mrc,
      cnam_mrc_comission,
      cnam_dip_local_comission,
      cnam_dip_comission,
      marketing_content,
      kyc_required,
      capture_projection,
      allow_rfq,
      sku,
      nda_required,
      product_summary,
      rate_margin,
      total_commission,
      product_title,
      is_default,
      selected_agreement,
      selected_form,
      isCpDefault,
      isComingSoon,
    } = this.state;
    // console.log("misc_rows: ", misc_rows);

    var is_validated = true;
    this.setState({
      nrc_error: false,
      nrc_error_text: "",
      mrc_error: false,
      mrc_error_text: "",
      rate_error: false,
      rate_error_text: "",
      sms_out_error: false,
      sms_out_error_text: "",
      sms_in_error_text: "",
      portin_error: false,
      portin_error_text: "",
      portout_error: false,
      portout_error_text: "",
    });
    if (service_title === "") {
      is_validated = false;
    } else if (
      this.state.service_type === "did" ||
      this.state.service_type === "tfn" ||
      this.state.service_type === "teams"
    ) {
      if (update_nrc === "") {
        is_validated = false;
      } else {
        if (update_nrc < this.state.default_nrc) {
          is_validated = false;
          this.setState({ nrc_error: true });
        }
        if (update_nrc > this.state.default_nrc) {
          let nrc_diff = update_nrc - this.state.default_nrc;
          let nrc_percentage = agent_nrc_comission;
          if (nrc_percentage > nrc_diff) {
            is_validated = false;
            this.setState({
              nrc_error: true,
              nrc_error_text:
                "Agent Spiff should be less than reseller margin.",
            });
          }
        }
      }
      if (portin !== "") {
        if (portin < this.state.defaultPortIn) {
          is_validated = false;
          this.setState({ portin_error: true });
        }
        if (portin > this.state.defaultPortIn) {
          let portin_diff = portin - this.state.defaultPortIn;
          let portin_percentage = agent_portin_comission;
          if (portin_percentage > portin_diff) {
            is_validated = false;
            this.setState({
              portin_error: true,
              portin_error_text:
                "Agent Spiff should be less than reseller margin.",
            });
          }
        }
      }
      if (portout !== "") {
        if (portout < this.state.defaultPortOut) {
          is_validated = false;
          this.setState({ portout_error: true });
        }
        if (portout > this.state.defaultPortOut) {
          let portout_diff = portout - this.state.defaultPortOut;
          let portout_percentage = agent_portout_comission;
          if (portout_percentage > portout_diff) {
            is_validated = false;
            this.setState({
              portout_error: true,
              portout_error_text:
                "Agent Spiff should be less than reseller margin.",
            });
          }
        }
      }
      if (agent_nrc_comission === "" || agent_nrc_comission === 0) {
        is_validated = false;
      } else {
        let nrc_diff = update_nrc - this.state.default_nrc;
        if (agent_nrc_comission > nrc_diff) {
          is_validated = false;
          this.setState({ nrc_comission_error: true });
        }
      }
      if (update_mrc === "") {
        is_validated = false;
      } else {
        if (update_mrc <= this.state.default_mrc) {
          is_validated = false;
          this.setState({ mrc_error: true });
        }
        if (update_mrc > this.state.default_mrc) {
          let mrc_diff = update_mrc - this.state.default_mrc;
          let mrc_percentage = (mrc_diff / 100) * agent_mrc_comission;
          if (mrc_percentage > mrc_diff) {
            is_validated = false;
            this.setState({
              mrc_error: true,
              mrc_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
      if (update_rate === "") {
        is_validated = false;
      } else {
        if (update_rate <= this.state.default_rate) {
          is_validated = false;
          this.setState({
            rate_error: true,
          });
        }
        if (update_rate > this.state.default_rate) {
          let rate_diff = this.formatRate(
            update_rate - this.state.default_rate,
          );
          let rate_percentage = this.formatRate(
            (rate_diff / 100) * agent_rate_comission,
          );

          if (rate_percentage > rate_diff) {
            is_validated = false;
            this.setState({
              rate_error: true,
              rate_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
    } else if (this.state.service_type === "term") {
      if (update_rate === "") {
        is_validated = false;
      } else {
        // console.log("rate > defaultRate: ", update_rate + " " + default_rate);
        if (update_rate <= default_rate) {
          is_validated = false;
          this.setState({
            rate_error: true,
          });
        }
        if (update_rate > default_rate) {
          let term_diff = update_rate - default_rate;
          let term_percentage = (term_diff / 100) * agent_rate_comission;
          if (term_percentage > term_diff) {
            is_validated = false;
            this.setState({
              rate_error: true,
              rate_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
    } else if (this.state.service_type === "tfn_term") {
      if (update_rate === "") {
        is_validated = false;
      } else {
        // console.log("rate > defaultRate: ", update_rate + " " + default_rate);
        if (update_rate <= default_rate) {
          is_validated = false;
          this.setState({
            rate_error: true,
          });
        }
        if (update_rate > default_rate) {
          let term_diff = update_rate - default_rate;
          let term_percentage = (term_diff / 100) * agent_rate_comission;
          if (term_percentage > term_diff) {
            is_validated = false;
            this.setState({
              rate_error: true,
              rate_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
    } else if (this.state.service_type === "az_term") {
      if (update_rate === "") {
        is_validated = false;
      } else {
        // console.log("rate > defaultRate: ", update_rate + " " + default_rate);
        if (update_rate <= default_rate) {
          is_validated = false;
          this.setState({
            rate_error: true,
          });
        }
        if (update_rate > default_rate) {
          let term_diff = update_rate - default_rate;
          let term_percentage = (term_diff / 100) * agent_rate_comission;
          if (term_percentage > term_diff) {
            is_validated = false;
            this.setState({
              rate_error: true,
              rate_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
    } else if (this.state.service_type === "ivr") {
      if (update_rate === "") {
        is_validated = false;
      } else {
        if (update_rate <= default_rate) {
          is_validated = false;
          this.setState({
            rate_error: true,
          });
        }
        if (update_rate > default_rate) {
          let term_diff = update_rate - default_rate;
          let term_percentage = (term_diff / 100) * agent_rate_comission;
          if (term_percentage > term_diff) {
            is_validated = false;
            this.setState({
              rate_error: true,
              rate_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
    } else if (this.state.service_type === "live_agent") {
      if (update_rate === "") {
        is_validated = false;
      } else {
        if (update_rate <= default_rate) {
          is_validated = false;
          this.setState({
            rate_error: true,
          });
        }
        if (update_rate > default_rate) {
          let term_diff = update_rate - default_rate;
          let term_percentage = (term_diff / 100) * agent_rate_comission;
          if (term_percentage > term_diff) {
            is_validated = false;
            this.setState({
              rate_error: true,
              rate_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
    } else if (this.state.service_type === "sms") {
      if (sms_in === "") {
        is_validated = false;
      } else {
        if (sms_in < this.state.default_sms_in) {
          is_validated = false;
          this.setState({
            sms_in_error: true,
          });
        }
        if (sms_in > this.state.default_sms_in) {
          let sms_in_diff = sms_in - this.state.default_sms_in;
          let sms_in_percentage = (sms_in_diff / 100) * sms_in_comission;

          if (sms_in_percentage > sms_in_diff) {
            is_validated = false;
            this.setState({
              sms_in_error: true,
              sms_in_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
      if (sms_out === "") {
        is_validated = false;
      } else {
        if (sms_out <= this.state.default_sms_out) {
          is_validated = false;
          this.setState({
            sms_out_error: true,
          });
        }
        if (sms_out > this.state.default_sms_out) {
          let sms_out_diff = sms_out - this.state.default_sms_out;
          let sms_out_percentage = (sms_out_diff / 100) * sms_out_comission;
          if (sms_out_percentage > sms_out_diff) {
            is_validated = true;
            this.setState({
              sms_out_error: true,
              sms_out_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
    } else if (this.state.service_type === "cnam") {
      if (cnam_mrc === "") {
        is_validated = false;
      } else {
        if (cnam_mrc < this.state.default_cnam_mrc) {
          is_validated = false;
          this.setState({
            cnam_mrc_error: true,
          });
        }
        if (cnam_mrc > this.state.default_cnam_mrc) {
          let cnam_mrc_diff = cnam_mrc - this.state.default_cnam_mrc;
          let cnam_mrc_percentage = (cnam_mrc_diff / 100) * cnam_mrc_comission;

          if (cnam_mrc_percentage > cnam_mrc_diff) {
            is_validated = false;
            this.setState({
              cnam_mrc_error: true,
              cnam_mrc_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
      if (cnam_dip === "") {
        is_validated = false;
      } else {
        if (cnam_dip <= this.state.default_cnam_dip) {
          is_validated = false;
          this.setState({
            cnam_dip_error: true,
          });
        }
        if (cnam_dip > this.state.default_cnam_dip) {
          let cnam_dip_diff = cnam_dip - this.state.default_cnam_dip;
          let cnam_dip_percentage = (cnam_dip_diff / 100) * cnam_dip_comission;
          if (cnam_dip_percentage > cnam_dip_diff) {
            is_validated = true;
            this.setState({
              cnam_dip_error: true,
              cnam_dip_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
      if (cnam_dip_local === "") {
        is_validated = false;
      } else {
        if (cnam_dip_local <= this.state.default_cnam_dip_local) {
          is_validated = false;
          this.setState({
            cnam_dip_local_error: true,
          });
        }
        if (cnam_dip_local > this.state.default_cnam_dip_local) {
          let cnam_dip_local_diff =
            cnam_dip_local - this.state.default_cnam_dip_local;
          let cnam_dip_local_percentage =
            (cnam_dip_local_diff / 100) * cnam_dip_local_comission;
          if (cnam_dip_local_percentage > cnam_dip_local_diff) {
            is_validated = true;
            this.setState({
              cnam_dip_local_error: true,
              cnam_dip_local_error_text:
                "Agent commission should be less than reseller margin.",
            });
          }
        }
      }
    }

    if (this.state.documentTitle === "") {
      is_validated = false;
      this.setState({
        docErrorMessage: "Document Title is required",
      });
    }

    // Rate Deck Pricing validation
    if (this.state.rate_deck_pricing) {
      if (
        !this.state.document &&
        !this.state.documentFileName &&
        !this.state.documentFile
      ) {
        is_validated = false;
        this.setState({
          rate_deck_file_error: true,
          rate_deck_file_error_text:
            "Please upload a rate deck file when Rate Deck Pricing is selected.",
        });
      }
    }

    if (is_validated === false) {
      return this.setState({
        errorMessage:
          "Please enter the required fields or check the highlighted text fields. ",
      });
    } else {
      this.setState({ errorMessage: "" });

      /*if (nrc_rate_type === "percentage") {
        update_nrc = this.calculatePercent(update_nrc, default_nrc);
      }
      if (mrc_rate_type === "percentage") {
        new_mrc = this.calculatePercent(new_mrc, defaultMrc);
      }
      if (min_rate_type === "percentage") {
        rate = this.calculatePercent(rate, defaultRate);
      }
      if (min_sms_in_type === "percentage") {
        sms_in = this.calculatePercent(sms_in, defaultSmsIn);
      }
      if (min_sms_out_type === "percentage") {
        sms_out = this.calculatePercent(sms_out, defaultSmsOut);
      }*/
      if (this.state.service_type == "term") {
        update_nrc = "";
        update_mrc = "";
        default_nrc = "";
        default_mrc = "";
        sms_in = "";
        sms_out = "";
        default_sms_in = "";
        default_sms_out = "";
        cnam_mrc = "";
        cnam_dip = "";
        cnam_dip_local = "";
        default_cnam_mrc = "";
        default_cnam_dip = "";
        default_cnam_dip_local = "";
      } else if (this.state.service_type == "ivr") {
        update_nrc = "";
        update_mrc = "";
        default_nrc = "";
        default_mrc = "";
        sms_in = "";
        sms_out = "";
        default_sms_in = "";
        default_sms_out = "";
        cnam_mrc = "";
        cnam_dip = "";
        cnam_dip_local = "";
        default_cnam_mrc = "";
        default_cnam_dip = "";
        default_cnam_dip_local = "";
      } else if (this.state.service_type == "tfn_term") {
        update_nrc = "";
        update_mrc = "";
        default_nrc = "";
        default_mrc = "";
        sms_in = "";
        sms_out = "";
        default_sms_in = "";
        default_sms_out = "";
        cnam_mrc = "";
        cnam_dip = "";
        cnam_dip_local = "";
        default_cnam_mrc = "";
        default_cnam_dip = "";
        default_cnam_dip_local = "";
      } else if (this.state.service_type == "az_term") {
        update_nrc = "";
        update_mrc = "";
        default_nrc = "";
        default_mrc = "";
        sms_in = "";
        sms_out = "";
        default_sms_in = "";
        default_sms_out = "";
        cnam_mrc = "";
        cnam_dip = "";
        cnam_dip_local = "";
        default_cnam_mrc = "";
        default_cnam_dip = "";
        default_cnam_dip_local = "";
      } else if (this.state.service_type == "live_agent") {
        update_nrc = "";
        update_mrc = "";
        default_nrc = "";
        default_mrc = "";
        sms_in = "";
        sms_out = "";
        default_sms_in = "";
        default_sms_out = "";
        cnam_mrc = "";
        cnam_dip = "";
        cnam_dip_local = "";
        default_cnam_mrc = "";
        default_cnam_dip = "";
        default_cnam_dip_local = "";
      } else if (this.state.service_type == "generic") {
        update_nrc = "";
        update_mrc = "";
        default_nrc = "";
        default_mrc = "";
        sms_in = "";
        sms_out = "";
        default_sms_in = "";
        default_sms_out = "";
        cnam_mrc = "";
        cnam_dip = "";
        cnam_dip_local = "";
        default_cnam_mrc = "";
        default_cnam_dip = "";
        default_cnam_dip_local = "";
      } else if (this.state.service_type == "did") {
        sms_in = "";
        sms_out = "";
        default_sms_in = "";
        default_sms_out = "";
        cnam_mrc = "";
        cnam_dip = "";
        cnam_dip_local = "";
        default_cnam_mrc = "";
        default_cnam_dip = "";
        default_cnam_dip_local = "";
      } else if (this.state.service_type == "tfn") {
        sms_in = "";
        sms_out = "";
        default_sms_in = "";
        default_sms_out = "";
        cnam_mrc = "";
        cnam_dip = "";
        cnam_dip_local = "";
        default_cnam_mrc = "";
        default_cnam_dip = "";
        default_cnam_dip_local = "";
      } else if (this.state.service_type == "sms") {
        update_nrc = "";
        update_mrc = "";
        default_nrc = "";
        default_mrc = "";
        default_rate = "";
        update_rate = "";
        cnam_mrc = "";
        cnam_dip = "";
        cnam_dip_local = "";
        default_cnam_mrc = "";
        default_cnam_dip = "";
        default_cnam_dip_local = "";
      } else if (this.state.service_type == "cnam") {
        update_nrc = "";
        update_mrc = "";
        default_nrc = "";
        default_mrc = "";
        default_rate = "";
        update_rate = "";
        sms_in = "";
        sms_out = "";
        default_sms_in = "";
        default_sms_out = "";
      }

      // console.log("select_service: ", select_service);
      // console.log("service_type: ", this.state.service_type);
      // console.log("service_title: ", this.state.service_title);
      // console.log("default_rate: ", default_rate);

      this.setState({
        errorMessage: "",
        //disabled: true,
      });

      let marketing_link = "";
      if (marketing_content === "link") {
        marketing_link = this.state.marketing_link;
      }

      // Handle Rate Deck Pricing mode
      let submit_misc_rows = misc_rows;
      let submit_generic_rows = generic_rows;
      let rate_deck_pricing_flag = this.state.rate_deck_pricing ? 1 : 0;

      if (this.state.rate_deck_pricing) {
        // When Rate Deck Pricing is enabled, clear/ignore rates and misc rates
        submit_misc_rows = [];
        submit_generic_rows = [];
      }

      const saveResponce = await serviceRatesUpdate(
        auth.getAccount(),
        auth.getToken(),
        update_nrc,
        update_mrc,
        update_rate,
        serviceId,
        service_title,
        this.state.service_type,
        this.state.product_desc,
        sms_in,
        sms_out,
        this.state.agent_mrc_comission,
        this.state.agent_nrc_comission,
        this.state.agent_rate_comission,
        this.state.default_mrc,
        this.state.default_rate,
        this.state.default_nrc,
        this.state.sms_in_comission,
        this.state.sms_out_comission,
        cancellation_fee,
        per_min_type,
        submit_misc_rows,
        submit_generic_rows,
        defaultPortIn,
        portin,
        agent_portin_comission,
        defaultPortOut,
        portout,
        agent_portout_comission,
        default_sms_in,
        default_sms_out,
        cnam_mrc,
        cnam_dip,
        cnam_dip_local,
        default_cnam_mrc,
        default_cnam_dip,
        default_cnam_dip_local,
        cnam_mrc_comission,
        cnam_dip_local_comission,
        cnam_dip_comission,
        this.state.defaultSessionRate,
        marketing_content,
        marketing_link,
        sku,
        kyc_required,
        capture_projection,
        allow_rfq,
        nda_required,
        this.state.select_integration,
        this.state.documentTitle,
        product_summary,
        rate_margin,
        total_commission,
        select_service,
        product_title,
        is_default,
        selected_agreement,
        selected_form,
        isCpDefault,
        isComingSoon,
        rate_deck_pricing_flag,
      );

      // console.log("ADD SERVICE RESPONSE: ", saveResponce.data);
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "fail" &&
        saveResponce.data.note !== ""
      ) {
        // window.location.replace("/error");
        return this.setState({
          errorMessage: "There is some error while updating the product.",
        });
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "sku_exists"
      ) {
        // window.location.replace("/error");
        document
          .getElementById("Services_Block_Ratedeck")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        return this.setState({
          errorMessage: "SKU already exists. Please add a unique SKU.",
        });
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "success"
      ) {
        //window.$("#modalAlert").modal("show");
        if (marketing_content === "file") {
          const marketing_link_array = await this.uploadFile(
            serviceId,
            marketing_link,
          );
          // console.log("marketing_link_array: ", marketing_link_array);
        }
        if (this.state.document !== "") {
          const doc_file_array = await this.uploadDocumentFile(serviceId);
          // console.log("doc_file_array: ", doc_file_array);
        }
        this.setState({
          errorMessage: "",
          successMessage: "Product updated successfully.",
          disabled: false,
          isBlocking: true,
        });

        $("#viewBtn").show();
        $("#btnloader").hide();
        setTimeout(() => {
          this.props.props.history.push("/services");
        }, 3000);
      } else {
        document
          .getElementById("Services_Block_Ratedeck")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        return this.setState({
          errorMessage: "There is some error while updating the product.",
        });
        //window.location.replace("/error");
      }
      document
        .getElementById("Services_Block_Ratedeck")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
    }
  };

  handleCpDefaultChange = () => {
    this.setState((prevState) => ({
      isCpDefault: !prevState.isCpDefault,
    }));
  };

  handleComingSoonChange = () => {
    this.setState((prevState) => ({
      isComingSoon: !prevState.isComingSoon,
    }));
  };

  handleRateDeckPricingChange = () => {
    const newValue = !this.state.rate_deck_pricing;
    this.setState(
      {
        rate_deck_pricing: newValue,
        rate_deck_file_error: false,
        rate_deck_file_error_text: "",
        isBlocking: false,
      },
      () => {
        if (newValue) {
          // When toggled on, scroll to and open the Document / Rate Deck section
          setTimeout(() => {
            const rateDeckSection =
              document.getElementById("rate-deck-section");
            if (rateDeckSection) {
              rateDeckSection.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
              // Focus the file input after scrolling
              setTimeout(() => {
                const fileInput = document.querySelector(
                  '#rate-deck-section input[type="file"]',
                );
                if (fileInput) {
                  fileInput.focus();
                }
              }, 500);
            }
            // Also ensure the docs_settings_tab is open
            if (!this.state.docs_settings_tab) {
              this.setState({ docs_settings_tab: true });
            }
          }, 100);
        }
      },
    );
  };

  uploadFile = async (service_id) => {
    //e.preventDefault();
    const { image_type, reseller_accountno } = this.state;
    if (this.state.fileName !== "") {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("file", this.state.file);
      formData.append("image_type", image_type);
      formData.append("accountno", reseller_accountno);
      formData.append("service_id", service_id);
      formData.append("fileName", this.state.fileName);

      axios
        .post(
          process.env.REACT_APP_API_URL + "uploads/upload_marketing_pdf",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": true,
            },
          },
          {},
        )
        .then((res) => {
          // console.log("File Upload RES ", res.data.data);
          if (
            res.data.status === 403 ||
            res.data.errors === "authentication missing" ||
            res.data.errors === "jwt expired"
          ) {
            return "error";
            this.setState({
              marketing_pdf: "",
            });
          } else if (res.data.status === 404) {
            return "error";
            this.setState({
              marketing_pdf: "",
            });
          } else if (
            res.data.status === 200 &&
            res.data.message === "success"
          ) {
            return res.data.data;
            this.setState({
              marketing_pdf: res.data.data,
            });
          } else {
            return "error";
            this.setState({
              marketing_pdf: "",
            });
          }
        });
    } else {
      return "error";
      this.setState({
        marketing_pdf: "",
      });
    }
  };

  uploadDocumentFile = async (service_id) => {
    //e.preventDefault();

    const { image_type, reseller_accountno } = this.state;
    if (this.state.documentFileName !== "") {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("file", this.state.document);
      formData.append("image_type", image_type);
      formData.append("accountno", reseller_accountno);
      formData.append("service_id", service_id);
      formData.append("fileName", this.state.documentFileName);
      formData.append("document_title", this.state.documentTitle);

      axios
        .post(
          process.env.REACT_APP_API_URL + "uploads/upload_product_document",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": true,
            },
          },
          {},
        )
        .then((res) => {
          // console.log("File Upload RES ", res.data);
          if (
            res.data.status === 403 ||
            res.data.errors === "authentication missing" ||
            res.data.errors === "jwt expired"
          ) {
            return "error";
            this.setState({
              documentFile: "",
            });
          } else if (res.data.status === 404) {
            return "error";
            this.setState({
              documentFile: "",
            });
          } else if (
            res.data.status === 200 &&
            res.data.message === "success"
          ) {
            return res.data.data;
            this.setState({
              documentFile: res.data.data,
            });
          } else {
            return "error";
            this.setState({
              documentFile: "",
            });
          }
        });
    } else {
      return "error";
      this.setState({
        documentFile: "",
      });
    }
  };

  calculatePercent = (percent, num) => {
    return (percent * (num / 100)).toFixed(this.decimalPoint);
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    // this.props.agreementSigned();
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  checkSku = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[a-zA-Z0-9\-_\.]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    //const image_type = this.state.edit_images_type;
    // console.log("file is ", e.target.files);
    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation
    const allowedFileTypes = [
      ".pdf",
      ".zip",
      ".xls",
      ".xlsx",
      ".doc",
      ".docx",
      ".csv",
    ]; //[".png", ".jpg", ".jpeg"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (!allowedFileTypes.includes(`.${fileExtension}`)) {
      this.setState({
        docErrorMessage:
          "Invalid file type. Please select a valid file format.",
      });
      return;
    }

    // File size validation (e.g., limit to 50MB)
    const maxSizeBytes = 50 * 1024 * 1024; // 50MB
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        docErrorMessage:
          "File size exceeds the limit (5MB). Please choose a smaller file.",
      });
      return;
    }
    this.setState({
      document: selectedFile,
      docErrorMessage: "",
      documentFileName: selectedFile.name,
      rate_deck_file_error: false,
      rate_deck_file_error_text: "",
      isBlocking: false,
    });
  };

  downloadDeck = async (d_f_name) => {
    if (d_f_name !== "") {
      var url = APP_LIVE_URL + "files_data/logos/" + d_f_name;
      const parts = url.split("/");
      let file_name = d_f_name;

      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    }
  };

  render() {
    const fetchToken = async () => {
      try {
        const response = await fetch(
          AGENT_SERVER_URL + "agents/editor_token_url",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              request_type: "ckeditor-tokenUrl",
              user: auth.getAccount(),
            }),
          },
        );
        const data = await response.json();
        return data.token;
      } catch (error) {
        console.error("Failed to fetch token:", error);
        return null;
      }
    };
    return (
      <div className="nk-content " id="Services_Block_Ratedeck">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          <Prompt
            when={this.state.isBlocking === false}
            message={() =>
              `Are you sure you want to leave this page without saving the changes.`
            }
          />
          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <HomeIcon fontSize="inherit" className="" />
                    Home
                  </Link>
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/services")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    Products
                  </Link>
                  <Typography color="textPrimary" className="">
                    Update Product & Service
                  </Typography>
                </Breadcrumbs>
                {/*<h3 className="nk-block-title page-title">
                  <PageTitle name="Add New Services" />
                </h3>*/}
              </div>
            </div>
          </div>
          {this.state.main_type && this.state.main_type === "ratedeck" ? (
            <div className="row g-4">
              <div className="col-md-12">
                <div className="card card-bordered">
                  <div className="card-inner">
                    <div
                      className="example-alert"
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-warning">
                        <div className="alert-text">
                          <h4>NOTE</h4>
                          <p>
                            Update feature for rate deck does available for now.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {this.state.main_type && this.state.main_type === "simple" ? (
            <div className="row g-4">
              <div className="col-md-12">
                <div className="card card-bordered">
                  <div className="card-inner">
                    {this.state.errorMessage !== "" ? (
                      <div
                        className="example-alert"
                        style={{ marginBottom: "15px" }}
                      >
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h4>Error</h4>
                            <p>{this.state.errorMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.successMessage !== "" ? (
                      <div
                        className="example-alert"
                        style={{ marginBottom: "15px" }}
                      >
                        <div className="alert alert-pro alert-success">
                          <div className="alert-text">
                            <h4>Success</h4>
                            <p>{this.state.successMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="modal fade" tabIndex="-1" id="modalAlert">
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHide();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                              <h4 className="nk-modal-title">
                                Flat Rate updated successfully.
                              </h4>
                              <div className="nk-modal-text">
                                <div className="caption-text">
                                  {this.state.successMessage}
                                </div>
                              </div>
                              <div className="nk-modal-action">
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="btn btn-lg btn-mw btn-primary"
                                  onClick={() => {
                                    this.modalHide();
                                  }}
                                >
                                  OK
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <form
                      method="post"
                      className="serviceForm"
                      onSubmit={this.formSave}
                      id="serviceForm"
                    autoComplete="off"
                    role="presentation"
                    >
                      <div className="nk-block-head nk-block-head-lg ">
                        <div className="nk-block-head-content">
                          <h2 className="nk-block-title fw-normal">
                            Update Product & Service
                          </h2>
                          <div className="nk-block-des">
                            <p>
                              Please add all the fields carefully while adding
                              the new product & service.{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="nk-block">
                        <div className="card card-bordered">
                          <div className="nk-kycfm">
                            <div
                              className="nk-kycfm-head"
                              style={{ background: "#f5f6fa" }}
                            >
                              <div className="nk-kycfm-count">01</div>
                              <div className="nk-kycfm-title">
                                <h5 className="title">General Settings</h5>
                                <p className="sub-title">
                                  Select product / service type and add title
                                  here.
                                </p>
                              </div>
                            </div>
                            {/* .nk-kycfm-head */}
                            <div className="nk-kycfm-content">
                              <div className="row g-4">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="These are the default services with default buy rates and settings."
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Select Type{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="select_service"
                                        name="select_service"
                                        select
                                        label="Select Type"
                                        value={this.state.select_service}
                                        onChange={this.handleChangeDefault}
                                        SelectProps={{
                                          native: true,
                                        }}
                                        helperText="Please select a service from default services"
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      >
                                        <option key="sets100" value=""></option>
                                        {this.state.defaultServices.map(
                                          (services, ind) => (
                                            <option
                                              key={`s${ind}`}
                                              value={services[0]}
                                            >
                                              {services[1]}
                                            </option>
                                          ),
                                        )}
                                      </MutextField>
                                    </div>
                                  </div>
                                </div>
                                {/* .col */}
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="Title of your service."
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Product Title{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        required
                                        id="service_title"
                                        name="service_title"
                                        type="text"
                                        helperText="Please provide a clear product or service title"
                                        value={this.state.service_title}
                                        onChange={this.handleChange}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="Stock Keeping Unit. It is a unique identifier assigned to a specific product to help manage inventory and keep track of stock levels."
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        SKU{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        required
                                        id="sku"
                                        name="sku"
                                        type="text"
                                        label="Enter unique SKU"
                                        defaultValue={this.state.sku}
                                        helperText="Enter a unique identifier (e.g., VOICE-001)"
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 30 }}
                                        onKeyPress={() => {
                                          this.checkSku();
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="If this agreement is changed, the previously assigned one will be revoked, and the new agreement will be assigned to all clients with this service. Please select an agreement from the list if you wish to attach one to this service."
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Select Agreement
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <Select2
                                        options={
                                          this.state.all_active_agreements
                                        }
                                        name="selected_accountno"
                                        placeholder="Select a service agreement"
                                        value={
                                          this.state.selected_agreement_array
                                        }
                                        autoComplete="off"
                                        emptyMessage="Agreement not found"
                                        onChange={
                                          this.handleChangeSearchAgreement
                                        }
                                        isClearable
                                        isSearchable
                                        components={animatedComponents}
                                        styles={{
                                          control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            lineHeight: "40px",
                                          }),
                                          menu: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9,
                                          }),
                                        }}
                                      />
                                      <small
                                        style={{
                                          marginLeft: "13px",
                                          color: "#0000008a",
                                        }}
                                      >
                                        Please select a service agreement
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="Select an order form from the list if you want to attach it to this service."
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Order Form
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <Select2
                                        options={this.state.all_active_forms}
                                        name="selected_accountno"
                                        placeholder="Select a form"
                                        value={this.state.selected_form_array}
                                        autoComplete="off"
                                        emptyMessage="Clients not found"
                                        onChange={this.handleChangeSearchForm}
                                        isClearable
                                        isSearchable
                                        components={animatedComponents}
                                        styles={{
                                          control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            lineHeight: "40px",
                                          }),
                                          menu: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9,
                                          }),
                                        }}
                                      />
                                      <small style={{ marginLeft: "13px" }}>
                                        Select an order form from the list if
                                        you want to attach it to this service.
                                      </small>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div
                                    className="form-group"
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="If checked, services will be assigned to newly registered channel partners automatically."
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                              marginRight: "6px",
                                            }}
                                          ></em>
                                        </Tooltip>
                                        Enable for{" "}
                                        {
                                          localization.specificPortals
                                            .agentsLabel
                                        }
                                      </label>
                                    </div>

                                    <div
                                      className="form-control-group d-flex"
                                      style={{ gap: "150px" }}
                                    >
                                      {/* ✅ Default for Agent checkbox */}
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={this.state.isCpDefault}
                                            onChange={
                                              this.handleCpDefaultChange
                                            }
                                            name="makeDefault"
                                          />
                                        }
                                        label={`Default for ${localization.specificPortals.agentLabel}`}
                                        style={{
                                          width: "max-content",
                                          marginBottom: "10px",
                                        }}
                                      />

                                      {/* ✅ Coming Soon checkbox with tooltip */}
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={
                                              this.state.isComingSoon || false
                                            }
                                            onChange={
                                              this.handleComingSoonChange
                                            }
                                            name="comingSoon"
                                          />
                                        }
                                        label={
                                          <span
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            Coming Soon{" "}
                                            <Tooltip
                                              placement="right"
                                              title={
                                                <div
                                                  style={{ maxWidth: "280px" }}
                                                >
                                                  <ul
                                                    style={{
                                                      paddingLeft: "18px",
                                                      margin: "5px 0",
                                                    }}
                                                  >
                                                    <li>
                                                      Admins can view{" "}
                                                      <b>pricing and details</b>
                                                      , but <b>cannot add</b>{" "}
                                                      these products to sales
                                                      orders or quotations.
                                                    </li>
                                                    <li>
                                                      Products marked as{" "}
                                                      <b>Coming Soon</b> will be
                                                      visible to clients and{" "}
                                                      {
                                                        localization
                                                          .specificPortals
                                                          .agentLabel
                                                      }
                                                      ,{" "}
                                                      <b>
                                                        but they cannot place
                                                        orders
                                                      </b>{" "}
                                                      for them.
                                                    </li>
                                                  </ul>
                                                </div>
                                              }
                                            >
                                              <em
                                                className="icon ni ni-info"
                                                style={{
                                                  color: "#6576ff",
                                                  marginLeft: "6px",
                                                  fontSize: "14px",
                                                  cursor: "pointer",
                                                }}
                                              ></em>
                                            </Tooltip>
                                          </span>
                                        }
                                        style={{
                                          width: "max-content",
                                          marginBottom: "10px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* .col */}
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        &nbsp;
                                      </label>
                                    </div>
                                    <ul className="nk-kycfm-control-list g-3">
                                      <li className="nk-kycfm-control-item">
                                        <input
                                          checked={this.state.kyc_required}
                                          onChange={
                                            this.handleChangeCheckboxKyc
                                          }
                                          className="nk-kycfm-control"
                                          type="checkbox"
                                          name="kyc_required"
                                          id="kyc_required"
                                          data-title="Kyc Required"
                                          value="Yes"
                                        autoComplete="new-password" />
                                        <label
                                          className="nk-kycfm-label"
                                          htmlFor="kyc_required"
                                        >
                                          <span className="nk-kycfm-label-icon">
                                            <div className="label-icon">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 90 90"
                                              >
                                                <rect
                                                  x="5"
                                                  y="7"
                                                  width="60"
                                                  height="56"
                                                  rx="7"
                                                  ry="7"
                                                  fill="#e3e7fe"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <rect
                                                  x="25"
                                                  y="27"
                                                  width="60"
                                                  height="56"
                                                  rx="7"
                                                  ry="7"
                                                  fill="#e3e7fe"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <rect
                                                  x="15"
                                                  y="17"
                                                  width="60"
                                                  height="56"
                                                  rx="7"
                                                  ry="7"
                                                  fill="#fff"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="15"
                                                  y1="29"
                                                  x2="75"
                                                  y2="29"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-miterlimit="10"
                                                  stroke-width="2"
                                                />
                                                <circle
                                                  cx="53"
                                                  cy="23"
                                                  r="2"
                                                  fill="#c4cefe"
                                                />
                                                <circle
                                                  cx="60"
                                                  cy="23"
                                                  r="2"
                                                  fill="#c4cefe"
                                                />
                                                <circle
                                                  cx="67"
                                                  cy="23"
                                                  r="2"
                                                  fill="#c4cefe"
                                                />
                                                <rect
                                                  x="22"
                                                  y="39"
                                                  width="20"
                                                  height="20"
                                                  rx="2"
                                                  ry="2"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <circle
                                                  cx="32"
                                                  cy="45.81"
                                                  r="2"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <path
                                                  d="M29,54.31a3,3,0,0,1,6,0"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="49"
                                                  y1="40"
                                                  x2="69"
                                                  y2="40"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="49"
                                                  y1="51"
                                                  x2="69"
                                                  y2="51"
                                                  fill="none"
                                                  stroke="#c4cefe"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="49"
                                                  y1="57"
                                                  x2="59"
                                                  y2="57"
                                                  fill="none"
                                                  stroke="#c4cefe"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="64"
                                                  y1="57"
                                                  x2="66"
                                                  y2="57"
                                                  fill="none"
                                                  stroke="#c4cefe"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="49"
                                                  y1="46"
                                                  x2="59"
                                                  y2="46"
                                                  fill="none"
                                                  stroke="#c4cefe"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="64"
                                                  y1="46"
                                                  x2="66"
                                                  y2="46"
                                                  fill="none"
                                                  stroke="#c4cefe"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                              </svg>
                                            </div>
                                          </span>
                                          <span className="nk-kycfm-label-text">
                                            KYC Required
                                          </span>
                                        </label>
                                      </li>
                                      <li className="nk-kycfm-control-item">
                                        <input
                                          checked={this.state.nda_required}
                                          onChange={
                                            this.handleChangeCheckboxKyc
                                          }
                                          className="nk-kycfm-control"
                                          type="checkbox"
                                          name="nda_required"
                                          id="nda_required"
                                          data-title="NDA Required"
                                          value="Yes"
                                        autoComplete="new-password" />
                                        <label
                                          className="nk-kycfm-label"
                                          htmlFor="nda_required"
                                        >
                                          <span className="nk-kycfm-label-icon">
                                            <div className="label-icon">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 90 90"
                                              >
                                                <rect
                                                  x="3"
                                                  y="10"
                                                  width="70"
                                                  height="50"
                                                  rx="7"
                                                  ry="7"
                                                  fill="#e3e7fe"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <rect
                                                  x="13"
                                                  y="24"
                                                  width="70"
                                                  height="50"
                                                  rx="7"
                                                  ry="7"
                                                  fill="#fff"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="20"
                                                  y1="33"
                                                  x2="31"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="75"
                                                  y1="33"
                                                  x2="77"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="66"
                                                  y1="33"
                                                  x2="67"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="70"
                                                  y1="33"
                                                  x2="72"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <rect
                                                  x="19"
                                                  y="40"
                                                  width="56"
                                                  height="7"
                                                  rx="2"
                                                  ry="2"
                                                  fill="#eff1ff"
                                                />
                                                <rect
                                                  x="20"
                                                  y="51"
                                                  width="24"
                                                  height="8"
                                                  rx="2"
                                                  ry="2"
                                                  fill="#eff1ff"
                                                />
                                                <rect
                                                  x="48"
                                                  y="51"
                                                  width="7"
                                                  height="8"
                                                  rx="2"
                                                  ry="2"
                                                  fill="#eff1ff"
                                                />
                                                <ellipse
                                                  cx="69"
                                                  cy="61.98"
                                                  rx="18"
                                                  ry="18.02"
                                                  fill="#fff"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <circle
                                                  cx="69"
                                                  cy="62"
                                                  r="7"
                                                  fill="#e3e7fe"
                                                />
                                                <polyline
                                                  points="77 56 77 60 73 60"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <path
                                                  d="M62.26,59.17a6.81,6.81,0,0,1,11.25-2.55L77,59.92"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <polyline
                                                  points="61 67 61 63 65 63"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <path
                                                  d="M61.43,64l3.51,3.31A6.83,6.83,0,0,0,76.2,64.79"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                              </svg>
                                            </div>
                                          </span>
                                          <span className="nk-kycfm-label-text">
                                            NDA Required
                                          </span>
                                        </label>
                                        <small style={{ marginLeft: "13px" }}>
                                          If checked, prices will be hidden from
                                          the customer unless they are
                                          registered and have signed the
                                          agreement.
                                        </small>
                                      </li>
                                      <li className="nk-kycfm-control-item">
                                        <input
                                          checked={this.state.is_default}
                                          onChange={
                                            this.handleChangeCheckboxKyc
                                          }
                                          className="nk-kycfm-control"
                                          type="checkbox"
                                          name="is_default"
                                          id="is_default"
                                          data-title="Default services will be assigned to newly registered clients."
                                          value="Yes"
                                        autoComplete="new-password" />
                                        <label
                                          className="nk-kycfm-label"
                                          htmlFor="is_default"
                                        >
                                          <span className="nk-kycfm-label-icon">
                                            <div className="label-icon">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 90 90"
                                              >
                                                <rect
                                                  x="3"
                                                  y="10"
                                                  width="70"
                                                  height="50"
                                                  rx="7"
                                                  ry="7"
                                                  fill="#e3e7fe"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <rect
                                                  x="13"
                                                  y="24"
                                                  width="70"
                                                  height="50"
                                                  rx="7"
                                                  ry="7"
                                                  fill="#fff"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="20"
                                                  y1="33"
                                                  x2="31"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="75"
                                                  y1="33"
                                                  x2="77"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="66"
                                                  y1="33"
                                                  x2="67"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="70"
                                                  y1="33"
                                                  x2="72"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <rect
                                                  x="19"
                                                  y="40"
                                                  width="56"
                                                  height="7"
                                                  rx="2"
                                                  ry="2"
                                                  fill="#eff1ff"
                                                />
                                                <rect
                                                  x="20"
                                                  y="51"
                                                  width="24"
                                                  height="8"
                                                  rx="2"
                                                  ry="2"
                                                  fill="#eff1ff"
                                                />
                                                <rect
                                                  x="48"
                                                  y="51"
                                                  width="7"
                                                  height="8"
                                                  rx="2"
                                                  ry="2"
                                                  fill="#eff1ff"
                                                />
                                                <ellipse
                                                  cx="69"
                                                  cy="61.98"
                                                  rx="18"
                                                  ry="18.02"
                                                  fill="#fff"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <circle
                                                  cx="69"
                                                  cy="62"
                                                  r="7"
                                                  fill="#e3e7fe"
                                                />
                                                <polyline
                                                  points="77 56 77 60 73 60"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <path
                                                  d="M62.26,59.17a6.81,6.81,0,0,1,11.25-2.55L77,59.92"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <polyline
                                                  points="61 67 61 63 65 63"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <path
                                                  d="M61.43,64l3.51,3.31A6.83,6.83,0,0,0,76.2,64.79"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                              </svg>
                                            </div>
                                          </span>
                                          <span className="nk-kycfm-label-text">
                                            Default
                                          </span>
                                        </label>
                                        <small style={{ marginLeft: "13px" }}>
                                          If checked, services will be assigned
                                          to newly registered clients
                                          automatically. It must be published as
                                          well.
                                        </small>
                                      </li>
                                      {/*<li className="nk-kycfm-control-item">
                                        <input
                                          checked={this.state.allow_rfq}
                                          onChange={
                                            this.handleChangeCheckboxKyc
                                          }
                                          className="nk-kycfm-control"
                                          type="checkbox"
                                          name="allow_rfq"
                                          id="allow_rfq"
                                          data-title="Capture Projection"
                                          value="Yes"
                                        />
                                        <label
                                          className="nk-kycfm-label"
                                          htmlFor="allow_rfq"
                                        >
                                          <span className="nk-kycfm-label-icon">
                                            <div className="label-icon">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 90 90"
                                              >
                                                <rect
                                                  x="3"
                                                  y="10"
                                                  width="70"
                                                  height="50"
                                                  rx="7"
                                                  ry="7"
                                                  fill="#e3e7fe"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <rect
                                                  x="13"
                                                  y="24"
                                                  width="70"
                                                  height="50"
                                                  rx="7"
                                                  ry="7"
                                                  fill="#fff"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="20"
                                                  y1="33"
                                                  x2="31"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="75"
                                                  y1="33"
                                                  x2="77"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="66"
                                                  y1="33"
                                                  x2="67"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <line
                                                  x1="70"
                                                  y1="33"
                                                  x2="72"
                                                  y2="33"
                                                  fill="none"
                                                  stroke="#9cabff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <rect
                                                  x="19"
                                                  y="40"
                                                  width="56"
                                                  height="7"
                                                  rx="2"
                                                  ry="2"
                                                  fill="#eff1ff"
                                                />
                                                <rect
                                                  x="20"
                                                  y="51"
                                                  width="24"
                                                  height="8"
                                                  rx="2"
                                                  ry="2"
                                                  fill="#eff1ff"
                                                />
                                                <rect
                                                  x="48"
                                                  y="51"
                                                  width="7"
                                                  height="8"
                                                  rx="2"
                                                  ry="2"
                                                  fill="#eff1ff"
                                                />
                                                <ellipse
                                                  cx="69"
                                                  cy="61.98"
                                                  rx="18"
                                                  ry="18.02"
                                                  fill="#fff"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <circle
                                                  cx="69"
                                                  cy="62"
                                                  r="7"
                                                  fill="#e3e7fe"
                                                />
                                                <polyline
                                                  points="77 56 77 60 73 60"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <path
                                                  d="M62.26,59.17a6.81,6.81,0,0,1,11.25-2.55L77,59.92"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <polyline
                                                  points="61 67 61 63 65 63"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                                <path
                                                  d="M61.43,64l3.51,3.31A6.83,6.83,0,0,0,76.2,64.79"
                                                  fill="none"
                                                  stroke="#6576ff"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                />
                                              </svg>
                                            </div>
                                          </span>
                                          <span className="nk-kycfm-label-text">
                                            Allow Request for Quotation
                                          </span>
                                        </label>
                                      </li>*/}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              {/* .row */}
                            </div>
                            {/* .nk-kycfm-content */}

                            <div
                              className="nk-kycfm-head"
                              style={{
                                background: "#f5f6fa",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                this.open_current_tab("desc_settings_tab");
                              }}
                              title="Click to open the Rate Settings"
                            >
                              <div className="nk-kycfm-count">02</div>
                              <div className="nk-kycfm-title">
                                <h5 className="title">Pricing</h5>
                                <p className="sub-title">
                                  Please enter pricing details carefully to
                                  ensure accurate information.
                                </p>
                              </div>
                            </div>
                            {/* .nk-kycfm-head */}
                            {this.state.rate_settings_tab === true ? (
                              <div className="nk-kycfm-content">
                                <div className="row g-4">
                                  {/* Rate Deck Pricing Toggle */}
                                  <div className="col-md-12">
                                    <div className="form-group">
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={
                                              this.state.rate_deck_pricing
                                            }
                                            onChange={
                                              this.handleRateDeckPricingChange
                                            }
                                            name="rate_deck_pricing"
                                            color="primary"
                                          />
                                        }
                                        label={
                                          <span>
                                            <strong>Rate Deck Pricing</strong>
                                            <Tooltip
                                              title="Upload a rate deck file instead of entering individual rates."
                                              placement="right"
                                            >
                                              <em
                                                className="icon ni ni-info"
                                                style={{
                                                  color: "#6576ff",
                                                  marginLeft: "8px",
                                                }}
                                              ></em>
                                            </Tooltip>
                                          </span>
                                        }
                                      />
                                    </div>
                                  </div>
                                  {/* End Rate Deck Pricing Toggle */}
                                  {!this.state.rate_deck_pricing &&
                                  this.state.service_type !== "term" &&
                                  this.state.service_type !== "sms" &&
                                  this.state.service_type !== "ivr" &&
                                  this.state.service_type !== "live_agent" &&
                                  this.state.service_type !== "tfn_term" &&
                                  this.state.service_type !== "az_term" &&
                                  this.state.service_type !== "cnam" &&
                                  this.state.service_type !== "generic" ? (
                                    <>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Cost for recurring monthly charges associated with phone number subscriptions."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              MRC Buy Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="default_mrc"
                                              name="default_mrc"
                                              label="MRC Buy Rate"
                                              value={this.state.default_mrc}
                                              variant="outlined"
                                              disabled
                                              fullWidth
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Rate for recurring monthly charges associated with phone number subscriptions."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              MRC Sell Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="update_mrc"
                                              name="update_mrc"
                                              type="text"
                                              label="MRC Sell Rate"
                                              value={this.state.update_mrc}
                                              onChange={this.handleChangeMrc}
                                              variant="outlined"
                                              helperText={
                                                this.state.mrc_error_text
                                              }
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={this.state.mrc_error}
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Commission amount for agent, taken out of profit."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Agent Commission{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="agent_mrc_comission"
                                              name="agent_mrc_comission"
                                              select
                                              label="Agent Commission"
                                              value={
                                                this.state.agent_mrc_comission
                                              }
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText={
                                                this.state
                                                  .mrc_comission_error_text
                                              }
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            >
                                              <option key="0" value="0">
                                                0%
                                              </option>
                                              <option key="5" value="5">
                                                5%
                                              </option>
                                              <option key="10" value="10">
                                                10%
                                              </option>
                                              <option key="15" value="15">
                                                15%
                                              </option>
                                              <option key="20" value="20">
                                                20%
                                              </option>
                                              <option key="25" value="25">
                                                25%
                                              </option>
                                              <option key="30" value="30">
                                                30%
                                              </option>
                                              <option key="35" value="35">
                                                35%
                                              </option>
                                              <option key="40" value="40">
                                                40%
                                              </option>
                                              <option key="45" value="45">
                                                45%
                                              </option>
                                              <option key="50" value="50">
                                                50%
                                              </option>
                                            </MutextField>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Cost for fixed phone number charges include the non-recurring setup charges."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              NRC Buy Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="default_nrc"
                                              label="NRC Buy Rate"
                                              value={this.state.default_nrc}
                                              variant="outlined"
                                              fullWidth
                                              disabled
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Rate for fixed phone number charges include the non-recurring setup charges."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              NRC Sell Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="update_nrc"
                                              name="update_nrc"
                                              type="text"
                                              label="NRC Sell Rate"
                                              value={this.state.update_nrc}
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              helperText={
                                                this.state.nrc_error_text
                                              }
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={this.state.nrc_error}
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Sales Performance Incentive Fund is an incentive amount earned against a sale / subscription."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Agent Spiff{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="agent_nrc_comission"
                                              name="agent_nrc_comission"
                                              type="text"
                                              label="Agent Spiff "
                                              value={
                                                this.state
                                                  .agent_nrc_comission &&
                                                this.state.agent_nrc_comission >
                                                  0
                                                  ? this.state
                                                      .agent_nrc_comission
                                                  : this.state
                                                      .agent_nrc_comission
                                              }
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              helperText="Agent Spiff will be less than the difference between buy and sell NRC rate."
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={
                                                this.state.nrc_comission_error
                                              }
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                  {this.state.service_type !== "sms" &&
                                  this.state.service_type !== "cnam" ? (
                                    <>
                                      {/*<div className="col-md-12">
                                        <ul
                                          className="nk-kycfm-control-list g-3"
                                          style={{ width: "33%" }}
                                        >
                                          <li className="nk-kycfm-control-item">
                                            <input
                                              checked={
                                                this.state.per_min_type ===
                                                "metered"
                                              }
                                              onChange={
                                                this.handleChangeCheckbox
                                              }
                                              className="nk-kycfm-control"
                                              type="radio"
                                              name="per_min_type"
                                              id="metered"
                                              data-title="Metered"
                                              value="metered"
                                            />
                                            <label
                                              className="nk-kycfm-label"
                                              htmlFor="metered"
                                            >
                                              <span className="nk-kycfm-label-icon">
                                                <div className="label-icon">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 71.9904 75.9285"
                                                  >
                                                    <path
                                                      d="M27.14,23.73A15.55,15.55,0,1,0,42.57,39.4v-.12A15.5,15.5,0,0,0,27.14,23.73Zm11.42,9.72H33a25.55,25.55,0,0,0-2.21-6.53A12.89,12.89,0,0,1,38.56,33.45ZM31,39.28a26.9929,26.9929,0,0,1-.2,3.24H23.49a26.0021,26.0021,0,0,1,0-6.48H30.8A29.3354,29.3354,0,0,1,31,39.28ZM26.77,26.36h.75a21.7394,21.7394,0,0,1,2.85,7.09H23.91A21.7583,21.7583,0,0,1,26.77,26.36Zm-3.28.56a25.1381,25.1381,0,0,0-2.2,6.53H15.72a12.88,12.88,0,0,1,7.78-6.53ZM14.28,39.28A13.2013,13.2013,0,0,1,14.74,36H20.9a29.25,29.25,0,0,0,0,6.48H14.74A13.1271,13.1271,0,0,1,14.28,39.28Zm1.44,5.83h5.57a25.9082,25.9082,0,0,0,2.2,6.53A12.89,12.89,0,0,1,15.72,45.11ZM27.51,52.2h-.74a21.7372,21.7372,0,0,1-2.85-7.09h6.44A21.52,21.52,0,0,1,27.51,52.2Zm3.28-.56A25.1413,25.1413,0,0,0,33,45.11h5.57a12.84,12.84,0,0,1-7.77,6.53Zm2.59-9.12a28.4606,28.4606,0,0,0,0-6.48h6.15a11.7,11.7,0,0,1,0,6.48ZM14.29,62.6H40v2.6H14.28V62.61ZM56.57,49l1.33-5,2.48.67-1.33,5Zm-6,22.52L55.24,54l2.48.67L53.06,72.14Zm21.6-61.24-29.8-8a5.13,5.13,0,0,0-6.29,3.61h0L33.39,16H6.57A2.58,2.58,0,0,0,4,18.55V70.38A2.57,2.57,0,0,0,6.52,73L6.57,73h29.7l17.95,4.85a5.12,5.12,0,0,0,6.28-3.6v-.06L75.8,16.61a5.18,5.18,0,0,0-3.6066-6.3763L72.18,10.23ZM6.57,70.38V18.55H45.14a2.57,2.57,0,0,1,2.57,2.57V67.79a2.57,2.57,0,0,1-2.55,2.59H6.57ZM73.34,15.91,58,73.48a2.59,2.59,0,0,1-2.48,1.93,2.5192,2.5192,0,0,1-.67-.09l-9-2.42a5.15,5.15,0,0,0,4.37-5.11V47.24l1.32.36,1.33-5-2.49-.67-.16.62V21.94l2.62.71,3.05,10,2.13.57L57.88,24l3.76,1,1.65,3,1.42.39-.25-4.09,2.24-3.42-1.41-.39L62.4,22.15l-3.76-1,4.76-7.92-2.13-.57-7.6,7.14-4-1.08A5.1,5.1,0,0,0,45.14,16H36.05l2.51-9.45a2.57,2.57,0,0,1,3.12-1.84h0l29.81,8.05a2.56,2.56,0,0,1,1.56,1.21A2.65,2.65,0,0,1,73.34,15.91ZM56.57,39.59l.66-2.5,2.44.65L59,40.24Zm4.88,1.31.66-2.51,2.44.66-.65,2.5Zm-9.76-2.61.66-2.51,2.45.66-.66,2.5Z"
                                                      transform="translate(-3.9995 -2.101)"
                                                      fill="#6476ff"
                                                    />
                                                  </svg>
                                                </div>
                                              </span>
                                              <span className="nk-kycfm-label-text">
                                                Metered
                                              </span>
                                            </label>
                                          </li>
                                         
                                          <li className="nk-kycfm-control-item">
                                            <input
                                              className="nk-kycfm-control"
                                              type="radio"
                                              name="per_min_type"
                                              id="unmetered"
                                              data-title="Unmetered"
                                              onChange={
                                                this.handleChangeCheckbox
                                              }
                                              checked={
                                                this.state.per_min_type ===
                                                "unmetered"
                                              }
                                              value="unmetered"
                                            />
                                            <label
                                              className="nk-kycfm-label"
                                              htmlFor="unmetered"
                                            >
                                              <span className="nk-kycfm-label-icon">
                                                <div className="label-icon">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 76 63.0105"
                                                  >
                                                    <path
                                                      d="M76,18.79,56.53,9.56a6.19,6.19,0,0,0-5.19,0l-19.5,9.23a3.35,3.35,0,0,0-1.9,2.55H8.33A6.26,6.26,0,0,0,2,27.51v38.3A6.27,6.27,0,0,0,8.33,72H71.67A6.27,6.27,0,0,0,78,65.81v-44A3.37,3.37,0,0,0,76,18.79Zm-.56,47a3.77,3.77,0,0,1-3.8,3.71H8.33a3.77,3.77,0,0,1-3.8-3.71V27.51a3.75,3.75,0,0,1,3.7993-3.7H29.87v9.34A34.49,34.49,0,0,0,44,60.41l7.51,5.8a4.11,4.11,0,0,0,4.94,0l7.51-5.8A36.5307,36.5307,0,0,0,75.47,45.62V65.81Zm0-32.66a32.09,32.09,0,0,1-13.1,25.34l-7.51,5.8a1.5,1.5,0,0,1-1.8,0l-7.51-5.8A32.05,32.05,0,0,1,32.4,33.15V21.83A.91.91,0,0,1,33,21l19.5-9.23a3.51,3.51,0,0,1,3,0L74.92,21a.91.91,0,0,1,.55.82V33.15ZM53.87,21.43a12.47,12.47,0,0,0-12.6,12.31,12.62,12.62,0,0,0,25.23,0,12.46,12.46,0,0,0-12.6178-12.3l-.0122,0Zm0,22.14A9.83,9.83,0,1,1,64,33.78a10,10,0,0,1-10.1,9.79Zm3.31-13.22-5.32,5.19-1.18-1.15a1.29,1.29,0,0,0-1.79,0,1.2,1.2,0,0,0-.013,1.697l.013.013h0l2.08,2a1.27,1.27,0,0,0,1.79,0L59,32.09a1.22,1.22,0,0,0,0-1.72h0a1.29,1.29,0,0,0-1.8,0ZM29.87,57.16h-20a1.24,1.24,0,1,0,0,2.47h20a1.24,1.24,0,0,0,0-2.47ZM19.73,62.1H9.89a1.24,1.24,0,0,0,0,2.48h9.84a1.24,1.24,0,0,0,0-2.48Zm8.66-14.28h0L24,45.71a.36.36,0,0,1-.22-.34V44.16a1.878,1.878,0,0,1,.18-.24,10.9991,10.9991,0,0,0,1.35-2.48,2.53,2.53,0,0,0,1.23-2.16V37.51a2.61,2.61,0,0,0-.46-1.43V34a4.69,4.69,0,0,0-1.15-3.43,6.68,6.68,0,0,0-5.19-1.85,6.67,6.67,0,0,0-5.18,1.85A4.61,4.61,0,0,0,13.4,34v2a2.46,2.46,0,0,0-.46,1.43v1.78a2.49,2.49,0,0,0,.78,1.81,10.148,10.148,0,0,0,1.52,3v1.2a.36.36,0,0,1-.21.33l-4.1,2.15A4.79,4.79,0,0,0,8.33,52v1.43a1.26,1.26,0,0,0,.37.88,1.33,1.33,0,0,0,.9.36H29.87a1.31,1.31,0,0,0,.9-.36,1.26,1.26,0,0,0,.37-.88V52.11A4.76,4.76,0,0,0,28.39,47.82Zm.21,4.4H10.87V52a2.27,2.27,0,0,1,1.25-2l4.12-2.16a2.85,2.85,0,0,0,1.54-2.5V43.72a1.3,1.3,0,0,0-.3-.8,7.39,7.39,0,0,1-1.4-2.8,1.53,1.53,0,0,0-.6-.83V37.46a1.22,1.22,0,0,0,.43-.92v-2.7a2.17,2.17,0,0,1,.53-1.58,4.38,4.38,0,0,1,3.28-1,4.43,4.43,0,0,1,3.26,1,2.22,2.22,0,0,1,.55,1.6.8552.8552,0,0,0,0,.16v2.56a1.36,1.36,0,0,0,.46,1l-.08,1.86a1.23,1.23,0,0,0-.84.8,8.5819,8.5819,0,0,1-1.19,2.31c-.1.14-.22.28-.33.41a1.22,1.22,0,0,0-.33.82v1.66A2.86,2.86,0,0,0,22.86,48l4.41,2a2.28,2.28,0,0,1,1.33,2.07v.15Z"
                                                      transform="translate(-2 -8.9898)"
                                                      fill="#6476ff"
                                                    />
                                                  </svg>
                                                </div>
                                              </span>
                                              <span className="nk-kycfm-label-text">
                                                Unmetered
                                              </span>
                                            </label>
                                          </li>
                                        </ul>
                                      </div>*/}

                                      {!this.state.rate_deck_pricing &&
                                      this.state.per_min_type === "metered" ? (
                                        <>
                                          <div className="col-md-2">
                                            <div className="form-group">
                                              <div className="form-label-group">
                                                <label className="form-label">
                                                  <Tooltip
                                                    title="Base cost of the product."
                                                    placement="right"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>{" "}
                                                  {this.state.service_type ===
                                                  "generic"
                                                    ? "Cost"
                                                    : "Per Min Buy Rate"}{" "}
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="form-control-group">
                                                <MutextField
                                                  disabled
                                                  id="default_rate"
                                                  name="default_rate"
                                                  label={
                                                    this.state.service_type ===
                                                    "generic"
                                                      ? "Buy Rate"
                                                      : "Per Min Buy Rate"
                                                  }
                                                  value={
                                                    this.state.default_rate
                                                  }
                                                  variant="outlined"
                                                  fullWidth
                                                autoComplete="new-password"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-md-2">
                                            <div className="form-group">
                                              <div className="form-label-group">
                                                <label className="form-label">
                                                  <Tooltip
                                                    title="Difference between Price and Cost."
                                                    placement="right"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>{" "}
                                                  {this.state.service_type ===
                                                  "generic"
                                                    ? "Margin"
                                                    : "Margin"}{" "}
                                                  <span className="text-danger"></span>
                                                </label>
                                              </div>
                                              <div className="form-control-group">
                                                <MutextField
                                                  disabled
                                                  id="rate_margin"
                                                  name="rate_margin"
                                                  label={
                                                    this.state.service_type ===
                                                    "generic"
                                                      ? "Margin"
                                                      : "Margin"
                                                  }
                                                  value={this.formatRate(
                                                    this.state.rate_margin,
                                                  )}
                                                  variant="outlined"
                                                  fullWidth
                                                autoComplete="new-password"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-md-2">
                                            <div className="form-group">
                                              <div className="form-label-group">
                                                <label className="form-label">
                                                  <Tooltip
                                                    title="Selling price of the product."
                                                    placement="right"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>{" "}
                                                  {this.state.service_type ===
                                                  "generic"
                                                    ? "Price"
                                                    : "Per Min Sell Rate"}{" "}
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="form-control-group">
                                                <MutextField
                                                  id="update_rate"
                                                  name="update_rate"
                                                  label={
                                                    this.state.service_type ===
                                                    "generic"
                                                      ? "Sell Rate"
                                                      : "Per Min Sell Rate"
                                                  }
                                                  value={this.state.update_rate}
                                                  onChange={this.handleChange}
                                                  variant="outlined"
                                                  helperText={
                                                    this.state.rate_error_text
                                                  }
                                                  type="text"
                                                  onKeyPress={() => {
                                                    this.checkNumber();
                                                  }}
                                                  fullWidth
                                                  error={this.state.rate_error}
                                                  disabled={
                                                    this.state.service_type ===
                                                    "generic"
                                                      ? true
                                                      : false
                                                  }
                                                autoComplete="new-password"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-md-2">
                                            <div className="form-group">
                                              <div className="form-label-group">
                                                <label className="form-label">
                                                  <Tooltip
                                                    title="Total value of the calculated commission."
                                                    placement="right"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>{" "}
                                                  {this.state.service_type ===
                                                  "generic"
                                                    ? "Commission Value"
                                                    : "Commission Value"}{" "}
                                                  <span className="text-danger"></span>
                                                </label>
                                              </div>
                                              <div className="form-control-group">
                                                <MutextField
                                                  disabled
                                                  id="total_commission"
                                                  name="total_commission"
                                                  label={
                                                    this.state.service_type ===
                                                    "generic"
                                                      ? "Margin"
                                                      : "Margin"
                                                  }
                                                  value={this.formatRate(
                                                    this.state.total_commission,
                                                  )}
                                                  variant="outlined"
                                                  fullWidth
                                                autoComplete="new-password"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      ) : null}
                                      {this.state.per_min_type ===
                                      "unmetered" ? (
                                        <>
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <div className="form-label-group">
                                                <label className="form-label">
                                                  <Tooltip
                                                    title="Buy rate for sessions you use."
                                                    placement="right"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>{" "}
                                                  {this.state.service_type ===
                                                  "generic"
                                                    ? "Sessions Buy Rate"
                                                    : "Per Buy Sell Rate"}{" "}
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="form-control-group">
                                                <MutextField
                                                  disabled
                                                  id="default_session_rate"
                                                  name="default_session_rate"
                                                  label={
                                                    this.state.service_type ===
                                                    "generic"
                                                      ? "Sessions Buy Rate"
                                                      : "Per Buy Sell Rate"
                                                  }
                                                  value={
                                                    this.state
                                                      .defaultSessionRate
                                                  }
                                                  variant="outlined"
                                                  fullWidth
                                                autoComplete="new-password"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <div className="form-label-group">
                                                <label className="form-label">
                                                  <Tooltip
                                                    title="Sell rate for sessions you use."
                                                    placement="right"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>{" "}
                                                  {this.state.service_type ===
                                                  "generic"
                                                    ? "Sessions Sell Rate"
                                                    : "Per Session Sell Rate"}{" "}
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="form-control-group">
                                                <MutextField
                                                  id="update_rate"
                                                  name="update_rate"
                                                  label={
                                                    this.state.service_type ===
                                                    "generic"
                                                      ? "Sessions Sell Rate"
                                                      : "Per Session Sell Rate"
                                                  }
                                                  defaultValue={
                                                    this.state.update_rate
                                                  }
                                                  onChange={this.handleChange}
                                                  variant="outlined"
                                                  helperText={
                                                    this.state.rate_error_text
                                                  }
                                                  type="text"
                                                  onKeyPress={() => {
                                                    this.checkNumber();
                                                  }}
                                                  fullWidth
                                                  error={this.state.rate_error}
                                                  disabled={
                                                    this.state.service_type ===
                                                    "generic"
                                                      ? true
                                                      : false
                                                  }
                                                autoComplete="new-password"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      ) : null}
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title={`Commission amount for ${localization.specificPortals.agentLabel.toLowerCase()}, taken out of profit.`}
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              {
                                                localization.specificPortals
                                                  .agentLabel
                                              }{" "}
                                              Commission{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="agent_rate_comission"
                                              name="agent_rate_comission"
                                              select
                                              label={`${localization.specificPortals.agentLabel} Commission`}
                                              value={
                                                this.state.agent_rate_comission
                                              }
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText={
                                                this.state
                                                  .rate_comission_error_text
                                              }
                                              variant="outlined"
                                              fullWidth
                                              error={
                                                this.state.rate_comission_error
                                              }
                                            autoComplete="new-password"
                                            >
                                              <option key="0" value="0">
                                                0%
                                              </option>
                                              <option key="5" value="5">
                                                5%
                                              </option>
                                              <option key="10" value="10">
                                                10%
                                              </option>
                                              <option key="15" value="15">
                                                15%
                                              </option>
                                              <option key="20" value="20">
                                                20%
                                              </option>
                                              <option key="25" value="25">
                                                25%
                                              </option>
                                              <option key="30" value="30">
                                                30%
                                              </option>
                                              <option key="35" value="35">
                                                35%
                                              </option>
                                              <option key="40" value="40">
                                                40%
                                              </option>
                                              <option key="45" value="45">
                                                45%
                                              </option>
                                              <option key="50" value="50">
                                                50%
                                              </option>
                                            </MutextField>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                  {!this.state.rate_deck_pricing &&
                                  this.state.service_type === "generic" ? (
                                    <>
                                      <div className="col-lg-12">
                                        <h6
                                          style={{
                                            borderTop: "1px solid #e5e9f2",
                                            paddingTop: "20px",
                                          }}
                                        >
                                          <Tooltip
                                            title="The defined charges or fees applied per charge type or time period."
                                            placement="right"
                                          >
                                            <em
                                              className="icon ni ni-info"
                                              style={{
                                                color: "#6576ff",
                                              }}
                                            ></em>
                                          </Tooltip>{" "}
                                          Rates
                                        </h6>
                                      </div>

                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <table
                                            className="table table-bordered"
                                            id="tab_logic"
                                          >
                                            <thead className="thead-light">
                                              <tr>
                                                <th
                                                  className="text-center"
                                                  style={{
                                                    lineHeight: "28px",
                                                  }}
                                                >
                                                  {" "}
                                                  Title{" "}
                                                </th>
                                                <th
                                                  className="text-center"
                                                  style={{
                                                    lineHeight: "28px",
                                                  }}
                                                >
                                                  {" "}
                                                  Charge Type{" "}
                                                </th>
                                                <th
                                                  className="text-center"
                                                  style={{
                                                    lineHeight: "28px",
                                                  }}
                                                >
                                                  {" "}
                                                  Cycle{" "}
                                                </th>
                                                <th
                                                  className="text-center"
                                                  style={{
                                                    lineHeight: "28px",
                                                  }}
                                                >
                                                  {" "}
                                                  Cost{" "}
                                                </th>
                                                <th
                                                  className="text-center"
                                                  style={{
                                                    lineHeight: "28px",
                                                  }}
                                                >
                                                  {" "}
                                                  Price{" "}
                                                </th>
                                                <th className="text-center">
                                                  {this.state.generic_rows
                                                    .length < 20 ? (
                                                    <span
                                                      className="badge badge-outline-success"
                                                      onClick={
                                                        this.handleAddRowGeneric
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                        paddingTop: "3px",
                                                        paddingBottom: "3px",
                                                        paddingLeft: "7px",
                                                        fontSize: "18px",
                                                      }}
                                                    >
                                                      <em className="icon ni ni-plus"></em>
                                                    </span>
                                                  ) : null}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state.generic_rows.map(
                                                (item, idx) => (
                                                  <tr
                                                    id={`addrr${idx}`}
                                                    key={`idxr${idx}`}
                                                  >
                                                    <td
                                                      style={{
                                                        paddingTop: "20px",
                                                      }}
                                                    >
                                                      <MutextField
                                                        id="generic_title"
                                                        name="generic_title"
                                                        label=""
                                                        value={
                                                          this.state
                                                            .generic_rows[idx]
                                                            .generic_title
                                                        }
                                                        variant="outlined"
                                                        onChange={this.handleChangeGeneric(
                                                          idx,
                                                        )}
                                                        fullWidth
                                                      autoComplete="new-password"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        paddingTop: "20px",
                                                      }}
                                                    >
                                                      <MutextField
                                                        id="pay_type"
                                                        name="pay_type"
                                                        select
                                                        label=""
                                                        value={
                                                          this.state
                                                            .generic_rows[idx]
                                                            .pay_type
                                                        }
                                                        onChange={this.handleChangeGeneric(
                                                          idx,
                                                        )}
                                                        SelectProps={{
                                                          native: true,
                                                        }}
                                                        helperText="Specify the type of charge (e.g., one-time, hourly, flat fee)."
                                                        variant="outlined"
                                                        fullWidth
                                                      autoComplete="new-password"
                                                      >
                                                        <option
                                                          key="per_minute1"
                                                          value="per_minute"
                                                        >
                                                          Select Charge Type
                                                        </option>

                                                        <option
                                                          key="recurring"
                                                          value="recurring"
                                                        >
                                                          Recurring
                                                        </option>
                                                        <option
                                                          key="one_time"
                                                          value="one_time"
                                                        >
                                                          Non-recurring
                                                        </option>
                                                      </MutextField>
                                                    </td>
                                                    <td
                                                      style={{
                                                        paddingTop: "20px",
                                                      }}
                                                    >
                                                      <MutextField
                                                        id="generic_type"
                                                        name="generic_type"
                                                        select
                                                        label=""
                                                        value={
                                                          this.state
                                                            .generic_rows[idx]
                                                            .generic_type
                                                        }
                                                        onChange={this.handleChangeGeneric(
                                                          idx,
                                                        )}
                                                        SelectProps={{
                                                          native: true,
                                                        }}
                                                        helperText="Select the billing cycle for your rate (e.g., hourly, daily, monthly)."
                                                        variant="outlined"
                                                        disabled={
                                                          this.state
                                                            .generic_rows[idx]
                                                            .pay_type ===
                                                          "one_time"
                                                            ? true
                                                            : false
                                                        }
                                                        fullWidth
                                                      autoComplete="new-password"
                                                      >
                                                        <option
                                                          key="per_minute11"
                                                          value="per_minutes"
                                                        >
                                                          Select Cycle
                                                        </option>
                                                        <option
                                                          key="per_second"
                                                          value="per_second"
                                                        >
                                                          Per Second
                                                        </option>
                                                        <option
                                                          key="per_minute"
                                                          value="per_minute"
                                                        >
                                                          Per Minute
                                                        </option>
                                                        <option
                                                          key="per_hour"
                                                          value="per_hour"
                                                        >
                                                          Per Hour
                                                        </option>
                                                        <option
                                                          key="per_day"
                                                          value="per_day"
                                                        >
                                                          Per Day
                                                        </option>
                                                        <option
                                                          key="per_month"
                                                          value="per_month"
                                                        >
                                                          Per Month
                                                        </option>
                                                        <option
                                                          key="per_year"
                                                          value="per_year"
                                                        >
                                                          Per Year
                                                        </option>
                                                      </MutextField>
                                                    </td>
                                                    <td
                                                      style={{
                                                        paddingTop: "20px",
                                                      }}
                                                    >
                                                      <MutextField
                                                        id="generic_buy_rate"
                                                        name="generic_buy_rate"
                                                        label="Buy Rate"
                                                        value={
                                                          this.state
                                                            .generic_rows[idx]
                                                            .generic_buy_rate
                                                        }
                                                        variant="outlined"
                                                        onChange={this.handleChangeGeneric(
                                                          idx,
                                                        )}
                                                        onKeyPress={() => {
                                                          this.checkNumber();
                                                        }}
                                                        fullWidth
                                                      autoComplete="new-password"
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        paddingTop: "20px",
                                                      }}
                                                    >
                                                      <MutextField
                                                        id="generic_rate"
                                                        name="generic_rate"
                                                        label="Sell Rate"
                                                        value={
                                                          this.state
                                                            .generic_rows[idx]
                                                            .generic_rate
                                                        }
                                                        variant="outlined"
                                                        onChange={this.handleChangeGeneric(
                                                          idx,
                                                        )}
                                                        onKeyPress={() => {
                                                          this.checkNumber();
                                                        }}
                                                        fullWidth
                                                      autoComplete="new-password"
                                                      />
                                                    </td>
                                                    <td
                                                      className="text-center"
                                                      style={{
                                                        paddingTop: "20px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <Tooltip
                                                        title={
                                                          item.includedInPrice !==
                                                          false
                                                            ? "Remove from price"
                                                            : "Add to price"
                                                        }
                                                        placement="top"
                                                      >
                                                        <span
                                                          className={
                                                            item.includedInPrice !==
                                                            false
                                                              ? "badge badge-outline-secondary"
                                                              : "badge badge-outline-success"
                                                          }
                                                          onClick={this.handleToggleIncludeInPrice(
                                                            idx,
                                                          )}
                                                          style={{
                                                            cursor: "pointer",
                                                            paddingTop: "3px",
                                                            paddingBottom:
                                                              "3px",
                                                            paddingLeft: "7px",
                                                            fontSize: "18px",
                                                            marginRight: "5px",
                                                            display:
                                                              "inline-block",
                                                          }}
                                                        >
                                                          <em className="icon ni ni-grid-plus"></em>
                                                        </span>
                                                      </Tooltip>
                                                      <span
                                                        className="badge badge-outline-danger"
                                                        onClick={this.handleRemoveSpecificRowGeneric(
                                                          idx,
                                                        )}
                                                        style={{
                                                          cursor: "pointer",
                                                          paddingTop: "3px",
                                                          paddingBottom: "3px",
                                                          paddingLeft: "7px",
                                                          fontSize: "18px",
                                                          display:
                                                            "inline-block",
                                                        }}
                                                      >
                                                        <em className="icon ni ni-trash"></em>
                                                      </span>
                                                    </td>
                                                  </tr>
                                                ),
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                  {!this.state.rate_deck_pricing &&
                                  this.state.service_type === "sms" ? (
                                    <>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Cost for SMS IN Services."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              SMS Inbound Buy Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              disabled
                                              id="default_sms_in"
                                              name="default_sms_in"
                                              label="SMS Inbound Buy Rate"
                                              value={this.state.default_sms_in}
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Price applied to SMS In Services."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              SMS Inbound Sell Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="sms_in"
                                              name="sms_in"
                                              label="SMS Inbound Sell Rate"
                                              value={this.state.sms_in}
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              helperText={
                                                this.state.sms_in_error_text
                                              }
                                              type="text"
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={this.state.sms_in_error}
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Commission amount for agent, taken out of profit."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Agent Commission{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="sms_in_comission"
                                              name="sms_in_comission"
                                              select
                                              label="Agent Commission"
                                              value={
                                                this.state.sms_in_comission
                                              }
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText={
                                                this.state.sms_in_comission_text
                                              }
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            >
                                              <option key="0" value="0">
                                                0%
                                              </option>
                                              <option key="5" value="5">
                                                5%
                                              </option>
                                              <option key="10" value="10">
                                                10%
                                              </option>
                                              <option key="15" value="15">
                                                15%
                                              </option>
                                              <option key="20" value="20">
                                                20%
                                              </option>
                                              <option key="25" value="25">
                                                25%
                                              </option>
                                              <option key="30" value="30">
                                                30%
                                              </option>
                                              <option key="35" value="35">
                                                35%
                                              </option>
                                              <option key="40" value="40">
                                                40%
                                              </option>
                                              <option key="45" value="45">
                                                45%
                                              </option>
                                              <option key="50" value="50">
                                                50%
                                              </option>
                                            </MutextField>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Cost for SMS Out Services."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              SMS Outbound Buy Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              disabled
                                              id="default_sms_out"
                                              name="default_sms_out"
                                              label="SMS Outbound Buy Rate"
                                              value={this.state.default_sms_out}
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Price applied to SMS Out Services."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              SMS Outbound Sell Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="sms_out"
                                              name="sms_out"
                                              label="SMS Outbound Sell Rate"
                                              value={this.state.sms_out}
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              type="text"
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={this.state.sms_out_error}
                                              helperText={
                                                this.state.sms_out_error_text
                                              }
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Commission amount for agent, taken out of profit."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Agent Commission{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="sms_out_comission"
                                              name="sms_out_comission"
                                              select
                                              label="Agent Commission"
                                              value={
                                                this.state.sms_out_comission
                                              }
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText={
                                                this.state
                                                  .sms_out_comission_text
                                              }
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            >
                                              <option key="0" value="0">
                                                0%
                                              </option>
                                              <option key="5" value="5">
                                                5%
                                              </option>
                                              <option key="10" value="10">
                                                10%
                                              </option>
                                              <option key="15" value="15">
                                                15%
                                              </option>
                                              <option key="20" value="20">
                                                20%
                                              </option>
                                              <option key="25" value="25">
                                                25%
                                              </option>
                                              <option key="30" value="30">
                                                30%
                                              </option>
                                              <option key="35" value="35">
                                                35%
                                              </option>
                                              <option key="40" value="40">
                                                40%
                                              </option>
                                              <option key="45" value="45">
                                                45%
                                              </option>
                                              <option key="50" value="50">
                                                50%
                                              </option>
                                            </MutextField>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                  {!this.state.rate_deck_pricing &&
                                  this.state.service_type === "cnam" ? (
                                    <>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Cost for Update CNAM (MRC)."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Update CNAM (MRC) Buy Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              disabled
                                              id="default_cnam_mrc"
                                              name="default_cnam_mrc"
                                              label="Update CNAM (MRC) Buy Rate"
                                              value={
                                                this.state.default_cnam_mrc
                                              }
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Price applied to Update CNAM (MRC)."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Update CNAM (MRC) Sell Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="cnam_mrc"
                                              name="cnam_mrc"
                                              label="Update CNAM (MRC) Sell Rate"
                                              value={this.state.cnam_mrc}
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              helperText={
                                                this.state.cnam_mrc_error_text
                                              }
                                              type="text"
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={this.state.cnam_mrc_error}
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Commission amount for agent, taken out of profit."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Agent Commission{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="cnam_mrc_comission"
                                              name="cnam_mrc_comission"
                                              select
                                              label="Agent Commission"
                                              value={
                                                this.state.cnam_mrc_comission
                                              }
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText={
                                                this.state
                                                  .cnam_mrc_comission_text
                                              }
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            >
                                              <option key="0" value="0">
                                                0%
                                              </option>
                                              <option key="5" value="5">
                                                5%
                                              </option>
                                              <option key="10" value="10">
                                                10%
                                              </option>
                                              <option key="15" value="15">
                                                15%
                                              </option>
                                              <option key="20" value="20">
                                                20%
                                              </option>
                                              <option key="25" value="25">
                                                25%
                                              </option>
                                              <option key="30" value="30">
                                                30%
                                              </option>
                                              <option key="35" value="35">
                                                35%
                                              </option>
                                              <option key="40" value="40">
                                                40%
                                              </option>
                                              <option key="45" value="45">
                                                45%
                                              </option>
                                              <option key="50" value="50">
                                                50%
                                              </option>
                                            </MutextField>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Cost for CNAM DIP."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              CNAM DIP Buy Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              disabled
                                              id="default_cnam_dip"
                                              name="default_cnam_dip"
                                              label="CNAM DIP Buy Rate"
                                              value={
                                                this.state.default_cnam_dip
                                              }
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Price applied to CNAM DIP."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              CNAM DIP Sell Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="cnam_dip"
                                              name="cnam_dip"
                                              label="CNAM DIP Sell Rate"
                                              value={this.state.cnam_dip}
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              type="text"
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={this.state.cnam_dip_error}
                                              helperText={
                                                this.state.cnam_dip_error_text
                                              }
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Commission amount for agent, taken out of profit."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Agent Commission{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="cnam_dip_comission"
                                              name="cnam_dip_comission"
                                              select
                                              label="Agent Commission"
                                              value={
                                                this.state.cnam_dip_comission
                                              }
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText={
                                                this.state
                                                  .cnam_dip_comission_text
                                              }
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            >
                                              <option key="0" value="0">
                                                0%
                                              </option>
                                              <option key="5" value="5">
                                                5%
                                              </option>
                                              <option key="10" value="10">
                                                10%
                                              </option>
                                              <option key="15" value="15">
                                                15%
                                              </option>
                                              <option key="20" value="20">
                                                20%
                                              </option>
                                              <option key="25" value="25">
                                                25%
                                              </option>
                                              <option key="30" value="30">
                                                30%
                                              </option>
                                              <option key="35" value="35">
                                                35%
                                              </option>
                                              <option key="40" value="40">
                                                40%
                                              </option>
                                              <option key="45" value="45">
                                                45%
                                              </option>
                                              <option key="50" value="50">
                                                50%
                                              </option>
                                            </MutextField>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Cost for Storage DIP."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Storage DIP Buy Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              disabled
                                              id="default_cnam_dip_local"
                                              name="default_cnam_dip_local"
                                              label="Storage DIP Buy Rate"
                                              value={
                                                this.state
                                                  .default_cnam_dip_local
                                              }
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Price applied to Storage DIP."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Storage DIP Sell Rate{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="cnam_dip_local"
                                              name="cnam_dip_local"
                                              label="Storage DIP Sell Rate"
                                              value={this.state.cnam_dip_local}
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              type="text"
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={
                                                this.state.cnam_dip_local_error
                                              }
                                              helperText={
                                                this.state
                                                  .cnam_dip_local_error_text
                                              }
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Commission amount for agent, taken out of profit."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Agent Commission{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="cnam_dip_local_comission"
                                              name="cnam_dip_local_comission"
                                              select
                                              label="Agent Commission"
                                              value={
                                                this.state
                                                  .cnam_dip_local_comission
                                              }
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText={
                                                this.state
                                                  .cnam_dip_local_comission_text
                                              }
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            >
                                              <option key="0" value="0">
                                                0%
                                              </option>
                                              <option key="5" value="5">
                                                5%
                                              </option>
                                              <option key="10" value="10">
                                                10%
                                              </option>
                                              <option key="15" value="15">
                                                15%
                                              </option>
                                              <option key="20" value="20">
                                                20%
                                              </option>
                                              <option key="25" value="25">
                                                25%
                                              </option>
                                              <option key="30" value="30">
                                                30%
                                              </option>
                                              <option key="35" value="35">
                                                35%
                                              </option>
                                              <option key="40" value="40">
                                                40%
                                              </option>
                                              <option key="45" value="45">
                                                45%
                                              </option>
                                              <option key="50" value="50">
                                                50%
                                              </option>
                                            </MutextField>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                  {/* .col */}
                                </div>
                                {/* .row */}
                              </div>
                            ) : null}

                            {/* .nk-kycfm-content */}
                            {!this.state.rate_deck_pricing && (
                              <div
                                className="nk-kycfm-head"
                                style={{
                                  background: "#f5f6fa",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  this.open_current_tab("misc_settings_tab");
                                }}
                                title="Click to open the Miscellaneous Rates / Cancellation Fee Settings"
                              >
                                <div className="nk-kycfm-count">03</div>
                                <div className="nk-kycfm-title">
                                  <h5 className="title">
                                    {localization.addProduct.miscHeading}
                                  </h5>
                                  <p className="sub-title">
                                    {localization.addProduct.miscHeadingText}
                                  </p>
                                </div>
                              </div>
                            )}
                            {/* .nk-kycfm-head */}

                            {!this.state.rate_deck_pricing &&
                            this.state.misc_settings_tab === true ? (
                              <div className="nk-kycfm-content">
                                <div className="row g-4">
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <div className="form-label-group">
                                        <label className="form-label">
                                          <Tooltip
                                            title="Fee for the cancellation of the service."
                                            placement="right"
                                          >
                                            <em
                                              className="icon ni ni-info"
                                              style={{
                                                color: "#6576ff",
                                              }}
                                            ></em>
                                          </Tooltip>{" "}
                                          Cancellation Fee{" "}
                                        </label>
                                      </div>
                                      <div className="form-control-group">
                                        <MutextField
                                          id="cancellation_fee"
                                          name="cancellation_fee"
                                          label="Cancellation Fee"
                                          onChange={this.handleChange}
                                          value={this.state.cancellation_fee}
                                          variant="outlined"
                                          onKeyPress={() => {
                                            this.checkNumber();
                                          }}
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <h6
                                      style={{
                                        borderTop: "1px solid #e5e9f2",
                                        paddingTop: "20px",
                                      }}
                                    >
                                      <Tooltip
                                        title={
                                          localization.addProduct
                                            .miscSubHeadingTip
                                        }
                                        placement="right"
                                      >
                                        <em
                                          className="icon ni ni-info"
                                          style={{
                                            color: "#6576ff",
                                          }}
                                        ></em>
                                      </Tooltip>{" "}
                                      {localization.addProduct.miscSubHeading}
                                    </h6>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <table
                                        className="table table-bordered"
                                        id="tab_logic"
                                      >
                                        <thead className="thead-light">
                                          <tr>
                                            <th
                                              className="text-center"
                                              style={{ lineHeight: "28px" }}
                                            >
                                              {" "}
                                              Rate Title{" "}
                                            </th>
                                            <th
                                              className="text-center"
                                              style={{ lineHeight: "28px" }}
                                            >
                                              {" "}
                                              Rate Type{" "}
                                            </th>
                                            <th
                                              className="text-center"
                                              style={{ lineHeight: "28px" }}
                                            >
                                              {" "}
                                              Rate{" "}
                                            </th>
                                            <th className="text-center">
                                              {this.state.misc_rows.length <
                                              5 ? (
                                                <span
                                                  className="badge badge-outline-success"
                                                  onClick={this.handleAddRow}
                                                  style={{
                                                    cursor: "pointer",
                                                    paddingTop: "3px",
                                                    paddingBottom: "3px",
                                                    paddingLeft: "7px",
                                                    fontSize: "18px",
                                                  }}
                                                >
                                                  <em className="icon ni ni-plus"></em>
                                                </span>
                                              ) : null}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.misc_rows.map(
                                            (item, idx) => (
                                              <tr
                                                id={`addr${idx}`}
                                                key={`idx${idx}`}
                                              >
                                                <td
                                                  style={{
                                                    paddingTop: "20px",
                                                  }}
                                                >
                                                  <MutextField
                                                    id={`misc_title${idx}`}
                                                    name="misc_title"
                                                    label="Rate Title"
                                                    defaultValue={
                                                      this.state.misc_rows[idx]
                                                        .misc_title
                                                    }
                                                    variant="outlined"
                                                    onChange={this.handleChangeMisc(
                                                      idx,
                                                    )}
                                                    fullWidth
                                                  autoComplete="new-password"
                                                  />
                                                </td>
                                                <td
                                                  style={{
                                                    paddingTop: "20px",
                                                  }}
                                                >
                                                  <MutextField
                                                    id={`misc_type${idx}`}
                                                    name="misc_type"
                                                    select
                                                    label="Rate Type"
                                                    defaultValue={
                                                      this.state.misc_rows[idx]
                                                        .misc_type
                                                    }
                                                    onChange={this.handleChangeMisc(
                                                      idx,
                                                    )}
                                                    SelectProps={{
                                                      native: true,
                                                    }}
                                                    helperText=""
                                                    variant="outlined"
                                                    fullWidth
                                                  autoComplete="new-password"
                                                  >
                                                    <option
                                                      key={`per_minute${idx}`}
                                                      value="per_minute"
                                                    >
                                                      Per Minute
                                                    </option>
                                                    <option
                                                      key={`per_hour${idx}`}
                                                      value="per_hour"
                                                    >
                                                      Per Hour
                                                    </option>
                                                    <option
                                                      key={`one_time${idx}`}
                                                      value="one_time"
                                                    >
                                                      One Time
                                                    </option>
                                                  </MutextField>
                                                </td>
                                                <td
                                                  style={{
                                                    paddingTop: "20px",
                                                  }}
                                                >
                                                  <MutextField
                                                    id={`misc_rate${idx}`}
                                                    name="misc_rate"
                                                    label="Rate"
                                                    value={
                                                      this.state.misc_rows[idx]
                                                        .misc_rate
                                                    }
                                                    variant="outlined"
                                                    onChange={this.handleChangeMisc(
                                                      idx,
                                                    )}
                                                    onKeyPress={() => {
                                                      this.checkNumber();
                                                    }}
                                                    fullWidth
                                                  autoComplete="new-password"
                                                  />
                                                </td>
                                                <td
                                                  className="text-center"
                                                  style={{
                                                    paddingTop: "20px",
                                                  }}
                                                >
                                                  <span
                                                    className="badge badge-outline-danger"
                                                    onClick={this.handleRemoveSpecificRow(
                                                      idx,
                                                    )}
                                                    style={{
                                                      cursor: "pointer",
                                                      paddingTop: "3px",
                                                      paddingBottom: "3px",
                                                      paddingLeft: "7px",
                                                      fontSize: "18px",
                                                    }}
                                                  >
                                                    <em className="icon ni ni-trash"></em>
                                                  </span>
                                                </td>
                                              </tr>
                                            ),
                                          )}
                                        </tbody>
                                      </table>

                                      {/*<button
                            onClick={this.handleRemoveRow}
                            className="btn btn-danger float-right"
                          >
                            Delete Last Row
                                      </button>*/}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            {this.state.service_type !== "term" &&
                            this.state.service_type !== "sms" &&
                            this.state.service_type !== "ivr" &&
                            this.state.service_type !== "live_agent" &&
                            this.state.service_type !== "tfn_term" &&
                            this.state.service_type !== "az_term" &&
                            this.state.service_type !== "cnam" &&
                            this.state.service_type !== "generic" ? (
                              <>
                                <div
                                  className="nk-kycfm-head"
                                  style={{
                                    background: "#f5f6fa",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    this.open_current_tab(
                                      "porting_settings_tab",
                                    );
                                  }}
                                  title="Click to open the Porting Settings"
                                >
                                  <div className="nk-kycfm-count">04</div>
                                  <div className="nk-kycfm-title">
                                    <h5 className="title">Porting Settings</h5>
                                    <p className="sub-title">
                                      You can add portin and portout buy rates,
                                      sell rates and agent spiffs here
                                    </p>
                                  </div>
                                </div>
                                {/* .nk-kycfm-head */}
                                {this.state.porting_settings_tab === true ? (
                                  <div className="nk-kycfm-content">
                                    <div className="row g-4">
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Port-in Cost"
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Port-in Buy Rate{" "}
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              disabled
                                              id="defaultPortIn"
                                              name="defaultPortIn"
                                              label="Port-in Buy Rate"
                                              value={this.state.defaultPortIn}
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Port-in Sell Rate"
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Port-in Sell Rate{" "}
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="portin"
                                              name="portin"
                                              type="text"
                                              label="Port-in Sell Rate"
                                              value={
                                                this.state.portin &&
                                                this.state.portin > 0
                                                  ? this.state.portin
                                                  : this.state.portin
                                              }
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              helperText={
                                                this.state.portin_error_text
                                              }
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={this.state.portin_error}
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Sales Performance Incentive Fund is an incentive amount earned against a sale / subscription."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Agent Spiff{" "}
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="agent_portin_comission"
                                              name="agent_portin_comission"
                                              type="text"
                                              label="Agent Spiff "
                                              value={
                                                this.state
                                                  .agent_portin_comission &&
                                                this.state
                                                  .agent_portin_comission > 0
                                                  ? this.state
                                                      .agent_portin_comission
                                                  : this.state
                                                      .agent_portin_comission
                                              }
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              helperText="Agent Spiff will be less than the difference between buy and sell Port-in rate."
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={
                                                this.state
                                                  .portin_comission_error
                                              }
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Port-out Cost."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Port-out Buy Rate{" "}
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              disabled
                                              id="defaultPortOut"
                                              name="defaultPortOut"
                                              label="Port-out Buy Rate"
                                              value={this.state.defaultPortOut}
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Port-out Sell Rate."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Port-out Sell Rate{" "}
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="portout"
                                              name="portout"
                                              type="text"
                                              label="Port-out Sell Rate"
                                              value={
                                                this.state.portout &&
                                                this.state.portout > 0
                                                  ? this.state.portout
                                                  : this.state.portout
                                              }
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              helperText={
                                                this.state.portout_error_text
                                              }
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={this.state.portout_error}
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <Tooltip
                                                title="Sales Performance Incentive Fund is an incentive amount earned against a sale / subscription."
                                                placement="right"
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                  }}
                                                ></em>
                                              </Tooltip>{" "}
                                              Agent Spiff{" "}
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="agent_portout_comission"
                                              name="agent_portout_comission"
                                              type="text"
                                              label="Agent Spiff "
                                              value={
                                                this.state
                                                  .agent_portout_comission &&
                                                this.state
                                                  .agent_portout_comission > 0
                                                  ? this.state
                                                      .agent_portout_comission
                                                  : this.state
                                                      .agent_portout_comission
                                              }
                                              onChange={this.handleChange}
                                              variant="outlined"
                                              helperText="Agent Spiff will be less than the difference between buy and sell Port-out rate."
                                              onKeyPress={() => {
                                                this.checkNumber();
                                              }}
                                              fullWidth
                                              error={
                                                this.state
                                                  .portout_comission_error
                                              }
                                            autoComplete="new-password"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </>
                            ) : null}

                            <div
                              className="nk-kycfm-head"
                              style={{
                                background: "#f5f6fa",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                this.open_current_tab("desc_settings_tab");
                              }}
                              title="Click to open the short description section"
                            >
                              <div className="nk-kycfm-count">
                                {this.state.rate_deck_pricing ? "03" : "04"}
                              </div>
                              <div className="nk-kycfm-title">
                                <h5 className="title">Description</h5>
                                <p className="sub-title">
                                  Description of the service
                                </p>
                              </div>
                            </div>
                            {/* .nk-kycfm-head */}
                            {this.state.desc_settings_tab === true ? (
                              <div className="nk-kycfm-content">
                                <div className="row g-4">
                                  <div className="col-md-12 col-lg-12 col-xxl-12">
                                    <div className="form-group">
                                      <div className="form-label-group">
                                        <label className="form-label">
                                          Summary{" "}
                                        </label>
                                      </div>
                                      <div className="form-control-group">
                                        <TextareaAutosize
                                          maxrows={10}
                                          name="product_summary"
                                          id="product_summary"
                                          aria-label=""
                                          placeholder=""
                                          value={this.state.product_summary}
                                          onChange={this.handleChange}
                                          style={{
                                            width: "100%",
                                            height: "200px",
                                            borderColor: "rgba(0, 0, 0, 0.125)",
                                            borderRadius: "4px",
                                          }}
                                          variant="outlined"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-12 col-lg-12 col-xxl-12">
                                    {this.state.isEditorReady ? (
                                      <>
                                        <RichTextEditorComponent
                                          agreementContent={
                                            this.state.product_desc
                                          }
                                          onContentChange={
                                            this.handleEditorChange
                                          }
                                        />
                                      </>
                                    ) : null}
                                  </div>
                                  <div className="col-md-12">
                                    <ul
                                      className="nk-kycfm-control-list g-3"
                                      style={{ width: "33%" }}
                                    >
                                      <li className="nk-kycfm-control-item">
                                        <input
                                          className="nk-kycfm-control"
                                          type="radio"
                                          name="marketing_content"
                                          id="marketing_link"
                                          data-title="Marketing Link"
                                          onChange={this.handleChangeCheckbox}
                                          checked={
                                            this.state.marketing_content ===
                                            "link"
                                          }
                                          value="link"
                                        autoComplete="new-password" />
                                        <label
                                          className="nk-kycfm-label"
                                          htmlFor="marketing_link"
                                        >
                                          <span className="nk-kycfm-label-icon">
                                            <div className="label-icon">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 76 63.0105"
                                              >
                                                <path
                                                  d="M76,18.79,56.53,9.56a6.19,6.19,0,0,0-5.19,0l-19.5,9.23a3.35,3.35,0,0,0-1.9,2.55H8.33A6.26,6.26,0,0,0,2,27.51v38.3A6.27,6.27,0,0,0,8.33,72H71.67A6.27,6.27,0,0,0,78,65.81v-44A3.37,3.37,0,0,0,76,18.79Zm-.56,47a3.77,3.77,0,0,1-3.8,3.71H8.33a3.77,3.77,0,0,1-3.8-3.71V27.51a3.75,3.75,0,0,1,3.7993-3.7H29.87v9.34A34.49,34.49,0,0,0,44,60.41l7.51,5.8a4.11,4.11,0,0,0,4.94,0l7.51-5.8A36.5307,36.5307,0,0,0,75.47,45.62V65.81Zm0-32.66a32.09,32.09,0,0,1-13.1,25.34l-7.51,5.8a1.5,1.5,0,0,1-1.8,0l-7.51-5.8A32.05,32.05,0,0,1,32.4,33.15V21.83A.91.91,0,0,1,33,21l19.5-9.23a3.51,3.51,0,0,1,3,0L74.92,21a.91.91,0,0,1,.55.82V33.15ZM53.87,21.43a12.47,12.47,0,0,0-12.6,12.31,12.62,12.62,0,0,0,25.23,0,12.46,12.46,0,0,0-12.6178-12.3l-.0122,0Zm0,22.14A9.83,9.83,0,1,1,64,33.78a10,10,0,0,1-10.1,9.79Zm3.31-13.22-5.32,5.19-1.18-1.15a1.29,1.29,0,0,0-1.79,0,1.2,1.2,0,0,0-.013,1.697l.013.013h0l2.08,2a1.27,1.27,0,0,0,1.79,0L59,32.09a1.22,1.22,0,0,0,0-1.72h0a1.29,1.29,0,0,0-1.8,0ZM29.87,57.16h-20a1.24,1.24,0,1,0,0,2.47h20a1.24,1.24,0,0,0,0-2.47ZM19.73,62.1H9.89a1.24,1.24,0,0,0,0,2.48h9.84a1.24,1.24,0,0,0,0-2.48Zm8.66-14.28h0L24,45.71a.36.36,0,0,1-.22-.34V44.16a1.878,1.878,0,0,1,.18-.24,10.9991,10.9991,0,0,0,1.35-2.48,2.53,2.53,0,0,0,1.23-2.16V37.51a2.61,2.61,0,0,0-.46-1.43V34a4.69,4.69,0,0,0-1.15-3.43,6.68,6.68,0,0,0-5.19-1.85,6.67,6.67,0,0,0-5.18,1.85A4.61,4.61,0,0,0,13.4,34v2a2.46,2.46,0,0,0-.46,1.43v1.78a2.49,2.49,0,0,0,.78,1.81,10.148,10.148,0,0,0,1.52,3v1.2a.36.36,0,0,1-.21.33l-4.1,2.15A4.79,4.79,0,0,0,8.33,52v1.43a1.26,1.26,0,0,0,.37.88,1.33,1.33,0,0,0,.9.36H29.87a1.31,1.31,0,0,0,.9-.36,1.26,1.26,0,0,0,.37-.88V52.11A4.76,4.76,0,0,0,28.39,47.82Zm.21,4.4H10.87V52a2.27,2.27,0,0,1,1.25-2l4.12-2.16a2.85,2.85,0,0,0,1.54-2.5V43.72a1.3,1.3,0,0,0-.3-.8,7.39,7.39,0,0,1-1.4-2.8,1.53,1.53,0,0,0-.6-.83V37.46a1.22,1.22,0,0,0,.43-.92v-2.7a2.17,2.17,0,0,1,.53-1.58,4.38,4.38,0,0,1,3.28-1,4.43,4.43,0,0,1,3.26,1,2.22,2.22,0,0,1,.55,1.6.8552.8552,0,0,0,0,.16v2.56a1.36,1.36,0,0,0,.46,1l-.08,1.86a1.23,1.23,0,0,0-.84.8,8.5819,8.5819,0,0,1-1.19,2.31c-.1.14-.22.28-.33.41a1.22,1.22,0,0,0-.33.82v1.66A2.86,2.86,0,0,0,22.86,48l4.41,2a2.28,2.28,0,0,1,1.33,2.07v.15Z"
                                                  transform="translate(-2 -8.9898)"
                                                  fill="#6476ff"
                                                />
                                              </svg>
                                            </div>
                                          </span>
                                          <span className="nk-kycfm-label-text">
                                            Marketing Link
                                          </span>
                                        </label>
                                      </li>
                                      <li className="nk-kycfm-control-item">
                                        <input
                                          checked={
                                            this.state.marketing_content ===
                                            "file"
                                          }
                                          onChange={this.handleChangeCheckbox}
                                          className="nk-kycfm-control"
                                          type="radio"
                                          name="marketing_content"
                                          id="file_select"
                                          data-title="File"
                                          value="file"
                                        autoComplete="new-password" />
                                        <label
                                          className="nk-kycfm-label"
                                          htmlFor="file_select"
                                        >
                                          <span className="nk-kycfm-label-icon">
                                            <div className="label-icon">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 71.9904 75.9285"
                                              >
                                                <path
                                                  d="M27.14,23.73A15.55,15.55,0,1,0,42.57,39.4v-.12A15.5,15.5,0,0,0,27.14,23.73Zm11.42,9.72H33a25.55,25.55,0,0,0-2.21-6.53A12.89,12.89,0,0,1,38.56,33.45ZM31,39.28a26.9929,26.9929,0,0,1-.2,3.24H23.49a26.0021,26.0021,0,0,1,0-6.48H30.8A29.3354,29.3354,0,0,1,31,39.28ZM26.77,26.36h.75a21.7394,21.7394,0,0,1,2.85,7.09H23.91A21.7583,21.7583,0,0,1,26.77,26.36Zm-3.28.56a25.1381,25.1381,0,0,0-2.2,6.53H15.72a12.88,12.88,0,0,1,7.78-6.53ZM14.28,39.28A13.2013,13.2013,0,0,1,14.74,36H20.9a29.25,29.25,0,0,0,0,6.48H14.74A13.1271,13.1271,0,0,1,14.28,39.28Zm1.44,5.83h5.57a25.9082,25.9082,0,0,0,2.2,6.53A12.89,12.89,0,0,1,15.72,45.11ZM27.51,52.2h-.74a21.7372,21.7372,0,0,1-2.85-7.09h6.44A21.52,21.52,0,0,1,27.51,52.2Zm3.28-.56A25.1413,25.1413,0,0,0,33,45.11h5.57a12.84,12.84,0,0,1-7.77,6.53Zm2.59-9.12a28.4606,28.4606,0,0,0,0-6.48h6.15a11.7,11.7,0,0,1,0,6.48ZM14.29,62.6H40v2.6H14.28V62.61ZM56.57,49l1.33-5,2.48.67-1.33,5Zm-6,22.52L55.24,54l2.48.67L53.06,72.14Zm21.6-61.24-29.8-8a5.13,5.13,0,0,0-6.29,3.61h0L33.39,16H6.57A2.58,2.58,0,0,0,4,18.55V70.38A2.57,2.57,0,0,0,6.52,73L6.57,73h29.7l17.95,4.85a5.12,5.12,0,0,0,6.28-3.6v-.06L75.8,16.61a5.18,5.18,0,0,0-3.6066-6.3763L72.18,10.23ZM6.57,70.38V18.55H45.14a2.57,2.57,0,0,1,2.57,2.57V67.79a2.57,2.57,0,0,1-2.55,2.59H6.57ZM73.34,15.91,58,73.48a2.59,2.59,0,0,1-2.48,1.93,2.5192,2.5192,0,0,1-.67-.09l-9-2.42a5.15,5.15,0,0,0,4.37-5.11V47.24l1.32.36,1.33-5-2.49-.67-.16.62V21.94l2.62.71,3.05,10,2.13.57L57.88,24l3.76,1,1.65,3,1.42.39-.25-4.09,2.24-3.42-1.41-.39L62.4,22.15l-3.76-1,4.76-7.92-2.13-.57-7.6,7.14-4-1.08A5.1,5.1,0,0,0,45.14,16H36.05l2.51-9.45a2.57,2.57,0,0,1,3.12-1.84h0l29.81,8.05a2.56,2.56,0,0,1,1.56,1.21A2.65,2.65,0,0,1,73.34,15.91ZM56.57,39.59l.66-2.5,2.44.65L59,40.24Zm4.88,1.31.66-2.51,2.44.66-.65,2.5Zm-9.76-2.61.66-2.51,2.45.66-.66,2.5Z"
                                                  transform="translate(-3.9995 -2.101)"
                                                  fill="#6476ff"
                                                />
                                              </svg>
                                            </div>
                                          </span>
                                          <span className="nk-kycfm-label-text">
                                            Marketing File (Image/PDF)
                                          </span>
                                        </label>
                                      </li>
                                      {/* .nk-kycfm-control-item */}
                                    </ul>
                                  </div>
                                  {this.state.marketing_content === "link" ? (
                                    <div className="col-md-12">
                                      <div className="form-group">
                                        <div className="form-label-group">
                                          <label className="form-label">
                                            <Tooltip
                                              title="Marketing Link."
                                              placement="right"
                                            >
                                              <em
                                                className="icon ni ni-info"
                                                style={{
                                                  color: "#6576ff",
                                                }}
                                              ></em>
                                            </Tooltip>{" "}
                                            Marketing Link{" "}
                                            <span className="text-danger"></span>
                                          </label>
                                        </div>
                                        <div className="form-control-group">
                                          <MutextField
                                            id="marketing_link"
                                            name="marketing_link"
                                            type="text"
                                            label="Marketing Link"
                                            defaultValue={
                                              this.state.marketing_link
                                            }
                                            onChange={this.handleChange}
                                            variant="outlined"
                                            fullWidth
                                          autoComplete="new-password"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.marketing_content === "file" ? (
                                    <div className="col-md-12">
                                      <div className="form-group">
                                        <label
                                          className="form-label"
                                          for="default-06"
                                        >
                                          <Tooltip
                                            title="Upload a marketing file (PDF, JPG, or PNG). Maximum file size: 2MB"
                                            placement="right"
                                          >
                                            <em
                                              className="icon ni ni-info"
                                              style={{
                                                color: "#6576ff",
                                              }}
                                            ></em>
                                          </Tooltip>{" "}
                                          Marketing File (PDF/Image) (
                                          <a
                                            href={this.state.marketing_link}
                                            target="_blank"
                                          >
                                            Download PDF
                                          </a>
                                          )
                                        </label>
                                        <div className="form-control-wrap">
                                          <div className="custom-file">
                                            <input
                                              type="file"
                                              accept=".pdf,.jpg,.jpeg,.png"
                                              onChange={(e) =>
                                                this.saveFilePdf(e)
                                              }
                                              defaultValue={this.state.file}
                                              multiple=""
                                              className="custom-file-input"
                                              id="customFile"
                                              name="customFile"
                                            />
                                            <label
                                              className="custom-file-label"
                                              for="customFile"
                                            >
                                              {this.state.fileName ||
                                                "Choose Marketing File (PDF/JPG/PNG - Max 2MB)"}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            ) : null}

                            <div
                              className="nk-kycfm-head"
                              style={{
                                background: "#f5f6fa",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                this.open_current_tab("docs_settings_tab");
                              }}
                              title="Click to open the Document section"
                            >
                              <div className="nk-kycfm-count">
                                {this.state.rate_deck_pricing ? "04" : "05"}
                              </div>
                              <div className="nk-kycfm-title">
                                <h5 className="title">
                                  {" "}
                                  Document / Rate Deck{" "}
                                  {this.state.rate_deck_pricing && (
                                    <span className="text-danger">*</span>
                                  )}
                                </h5>
                                <p className="sub-title">
                                  {this.state.rate_deck_pricing
                                    ? "Upload a rate deck file. This is required when Rate Deck Pricing is enabled."
                                    : "Upload any service configuration or rate deck that becomes available once the service is activated for the customer."}
                                </p>
                              </div>
                            </div>

                            {this.state.docs_settings_tab === true ? (
                              <div
                                className="nk-kycfm-content"
                                id="rate-deck-section"
                              >
                                <div className="row g-4">
                                  <div className="col-md-12">
                                    <ul
                                      className="nk-kycfm-control-list g-3"
                                      style={{ width: "33%" }}
                                    >
                                      {/* .nk-kycfm-control-item */}
                                    </ul>
                                  </div>
                                  {this.state.docErrorMessage !== "" ? (
                                    <div className="col-md-12 mb-3">
                                      <div
                                        className="example-alert example-alert-revoke"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>Error</h4>
                                            <p>{this.state.docErrorMessage}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="form-label-group">
                                        <label
                                          className="form-label"
                                          for="default-06"
                                        >
                                          Document Title
                                        </label>
                                      </div>
                                      <div className="form-control-group">
                                        <MutextField
                                          id="documentTitle"
                                          name="documentTitle"
                                          label="Document Title"
                                          defaultValue={
                                            this.state.documentTitle
                                          }
                                          variant="outlined"
                                          onChange={this.handleChange}
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="default-06"
                                      >
                                        <Tooltip
                                          title="Product Document."
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Product File{" "}
                                        {this.state.rate_deck_pricing && (
                                          <span className="text-danger">*</span>
                                        )}
                                        {this.state.documentFile &&
                                        this.state.documentFile !== "" ? (
                                          <>
                                            {" "}
                                            (
                                            <a
                                              onClick={() =>
                                                this.downloadDeck(
                                                  this.state.documentFile,
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                              className="text-primary"
                                            >
                                              Download Document
                                            </a>
                                            )
                                          </>
                                        ) : null}
                                      </label>
                                      <div className="form-control-wrap">
                                        <div className="custom-file">
                                          <input
                                            type="file"
                                            //accept=".pdf"
                                            accept=".pdf, .zip, .xls, .xlsx, .doc, .docx, .csv"
                                            onChange={this.handleFileChange}
                                            defaultValue={this.state.document}
                                            multiple=""
                                            className="custom-file-input"
                                            id="documentFile"
                                            name="documentFile"
                                          autoComplete="new-password" />
                                          <label
                                            className="custom-file-label"
                                            for="documentFile"
                                          >
                                            {this.state.documentFileName
                                              ? this.state.documentFileName
                                              : "Choose Product Document"}
                                          </label>
                                          {this.state.rate_deck_file_error && (
                                            <p className="text-danger mt-2">
                                              {
                                                this.state
                                                  .rate_deck_file_error_text
                                              }
                                            </p>
                                          )}
                                          <p className="mt-2">
                                            {" "}
                                            Accepted formats: PDF, ZIP, XLS,
                                            XLSX, DOC, DOCX, CSV.{" "}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.integrationData &&
                            this.state.integrationData.length > 0 ? (
                              <>
                                <div
                                  className="nk-kycfm-head"
                                  style={{
                                    background: "#f5f6fa",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    this.open_current_tab(
                                      "intigration_settings_tab",
                                    );
                                  }}
                                  title="Click to open the Integration section"
                                >
                                  <div className="nk-kycfm-count">06</div>
                                  <div className="nk-kycfm-title">
                                    <h5 className="title">
                                      3rd Party Integration{" "}
                                    </h5>
                                    <p className="sub-title">
                                      Choose any third-party API or integration
                                      to activate once the service is enabled
                                      for the customer.
                                    </p>
                                  </div>
                                </div>

                                {this.state.intigration_settings_tab ===
                                true ? (
                                  <div className="nk-kycfm-content">
                                    <div className="row g-4">
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              Select Integration{" "}
                                              {/* <span className="text-danger">
                                                  *
                                                </span> */}
                                            </label>
                                          </div>
                                          <div className="form-control-group">
                                            <MutextField
                                              id="select_integration"
                                              name="select_integration"
                                              select
                                              label="Select Integration"
                                              value={
                                                this.state.select_integration
                                              }
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText="Please select an integration."
                                              variant="outlined"
                                              fullWidth
                                            autoComplete="new-password"
                                            >
                                              <option
                                                key="sets100"
                                                value=""
                                              ></option>
                                              {this.state.integrationData.map(
                                                (integration, index) => (
                                                  <option
                                                    key={`sets${index}`}
                                                    value={
                                                      integration.integration_type
                                                    }
                                                  >
                                                    {
                                                      integration.integration_title
                                                    }
                                                  </option>
                                                ),
                                              )}
                                            </MutextField>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </>
                            ) : null}

                            <div className="nk-kycfm-footer">
                              <div className="nk-kycfm-action pt-2 text-right">
                                <a
                                  onClick={() =>
                                    this.addMenuHistory("/services")
                                  }
                                  className="btn btn-lg btn-light"
                                  disabled={this.state.disabled}
                                  style={{ marginRight: "15px" }}
                                >
                                  <em className="icon ni ni-step-back"></em>
                                  Back
                                </a>
                                <button
                                  type="submit"
                                  className="btn btn-lg btn-primary"
                                  disabled={this.state.disabled}
                                >
                                  Update Service
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* .nk-kycfm */}
                        </div>
                        {/* .card */}
                      </div>
                      {/* nk-block */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Editservice);
